import moment from "moment";
import { Base64 } from "base64-string";
import { v4 as uuidv4 } from "uuid";
import { Slide, toast } from "react-toastify";

import { ShopifySingleIcon } from "../assets/icons/iconsProvider";
import TableCustomHeader from "./components/table/TableCustomHeader";
import { DEFAULT_TAGS, SYSTEM_SUBCATEGORY } from "./DefaultCategories";
import { inventoryService, shopifyService, storeService } from "../services";
import { emailRegex, phoneRegex } from "./validationSchema/validationSchema";
import {
  customerConstants,
  datepickerConstants,
  discountConstants,
  EMPTY_STRING,
  GENRE_SUB_CATEGORY,
  globalConstants,
  IMAGE_FILE_TYPES,
  INSTOCK_FILTER_OPTIONS,
  INVENTORY_MODAL_TYPES,
  inventoryConstants,
  LOGS_TYPES,
  NETWORK_AVERAGE_PRICE_RANGES,
  NETWORK_AVERAGE_PRICE_TYPES,
  outletConstants,
  preserveMode,
  printerConstants,
  systemConstants,
  toastMessages,
  toastType,
  toggleSwitchButtonConstants,
  tradeInDiscountConstant,
  transactionConstants,
} from "../constants";
import {
  CUSTOM_FILTER_ENUMS,
  DATE_FORMAT,
  EMAIL_MESSAGE_TYPES,
  NOTIFICATION_TYPES,
  PRODUCT_CONDITIONS_ENUMS,
  PRODUCT_TYPES_ENUMS,
  SET_BY_MARGIN_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
} from "../system/globalEnums";
import {
  getItemFromLocalStorage,
  setItemToLocalStorage,
} from "../system/storage";
import {
  isShopifyConnected,
  isStoreCustomProduct,
  getMappedShopifyFields,
  handleBeautifyMarketPrice,
  getSellTradeCustomerObject,
  getCustomProductConditionList,
  handleOnchangeTradingCardCondition,
  getTradingCardMarketPriceForSelectedProperties,
} from "./utility";
import { getQuantityValue } from "./utility";

//-------Stringfy the Object
export const stringifyObject = (object) => {
  return JSON.stringify(object);
};

//-------Parse Json Object
export const parseJsonObject = (object) => {
  return JSON.parse(object);
};

//-------Updtae Object
export const updateObject = (oldObject, updatedProperties) => ({
  ...oldObject,
  ...updatedProperties,
});

//-------Custom Toast
export const customToast = (
  AllErrorMessages,
  type = toastType.INFO,
  time = 4000,
  position
) => {
  const options = {
    autoClose: time,
    type,
    hideProgressBar: true,
    position,
    pauseOnHover: true,
    transition: Slide,
    className: "primary",
  };
  if (Array.isArray(AllErrorMessages)) {
    AllErrorMessages.forEach((message) => {
      toast(message, options);
    });
  } else {
    toast(AllErrorMessages, options);
  }
};
const getMarketPriceAfterPreset = (currentStore, item, markupPresets) => {
  return currentStore?.[
    toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
  ]
    ? getPresetStockPrice(
        item.productType,
        item.marketPrice,
        markupPresets,
        item
      )
    : item.marketPrice;
};

export const stringToPascal = (text) =>
  text.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
    return g1.toUpperCase() + g2.toLowerCase();
  });

function convertArrayOfObjectsToCSV(array) {
  if (array.length === 0) {
    return "";
  }

  let result;

  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  const keys = Object.keys(array[0]);

  result = "";
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((item) => {
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key];

      ctr++;
    });
    result += lineDelimiter;
  });
  return result;
}

export function downloadCSV(
  array,
  fileName,
  date = `${new Date().toISOString().slice(8, 10)}-${new Date()
    .toISOString()
    .slice(5, 7)}-${new Date().toISOString().slice(0, 4)}`
) {
  if (array.length === 0) {
    customToast(toastMessages.CANNOT_BE_EXPORT_ARRAY_EMPTY, toastType.ERROR);
    return;
  }
  const link = document.createElement("a");
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const filename = `${fileName ? fileName : "export"}-${date}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${encodeURI(csv).replaceAll(
      "#",
      "%23"
    )}`;
  }

  link.setAttribute("href", csv);
  link.setAttribute("download", filename);
  link.click();
}

// "2023-12-29T09:47:59.2060000Z" to "MM/DD/YYYY"
export function formatDate(dateString, isWordFormat = false) {
  let formattedDate = EMPTY_STRING;
  if (isWordFormat) {
    formattedDate = moment(dateString).format("MMMM Do YYYY");
  } else {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    formattedDate = new Date(dateString).toLocaleDateString("en-US", options);
  }
  return formattedDate;
}

export function formatTime(dateString) {
  // Create a new Date object from the date string
  const date = new Date(dateString);

  // Format the time only, excluding the date
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}
//-------convert value to usd
export const convertToUsd = (number) => {
  if (number) {
    return (number / 100).toFixed(2);
  } else return 0;
};

export const usdToOriginal = (usdValue) => {
  const number = parseFloat(usdValue);
  if (!isNaN(number)) {
    return (number * 100).toFixed(2);
  } else return parseToThousandSeperatorDecimalNumber(0);
};
//-------slugify the sring
export const stringToSlug = (str) => {
  return str
    ? str
        .toLowerCase()
        .replace(/[^\w\s&'-]/g, "") // Remove non-word characters, excluding spaces, dashes, single quotes, and ampersands
        .replace(/\s+/g, "-") // Replace spaces with dashes
        .replace(/'/g, "%27") // Replace single quotes with %27
        .trim() // Trim leading/trailing whitespace
    : EMPTY_STRING;
};
export const getCategoryDiscount = (category, categoryDiscounts) => {
  const validDiscounts = categoryDiscounts.filter((discount) => {
    return (
      discount.categoryName === category &&
      checkDiscountValidity(discount.startDate, discount.endDate)
    );
  });

  if (validDiscounts.length > 0) {
    // Sort valid discounts based on end date in descending order
    validDiscounts.sort(
      (a, b) =>
        moment.utc(b.endDate).valueOf() - moment.utc(a.endDate).valueOf()
    );
    return validDiscounts[0]; // Return the discount with the latest end date
  } else {
    return null; // No valid discount found
  }
};

export const checkDiscountValidity = (startDate, endDate) => {
  const currentUtcMoment = moment.utc();
  const start = moment.utc(startDate);
  const end = moment.utc(endDate);
  const isValid = currentUtcMoment.isBetween(start, end, null, "[]");
  return isValid;
};

export const convertToFixedPrecision = (value) => {
  let updatedNumber = parseFloat(Number(value).toFixed(2));
  return isNaN(updatedNumber) ? 0 : updatedNumber;
};

export const getGlobalRatio = (currentStore) => {
  return (
    currentStore?.globalTradeinMargin.cashMarginPercentage /
    currentStore?.globalTradeinMargin.tradeinMarginPercentage
  );
};

export const getStandardRatio = (currentStore, categoryName) => {
  return (
    currentStore?.categoryTradeinMargin.find(
      (category) => category.categoryName === categoryName
    )?.cashMarginPercentage /
      currentStore.categoryTradeinMargin.find(
        (category) => category.categoryName === categoryName
      )?.tradeinMarginPercentage || 0
  );
};

export const getSumOfPaymentHistory = (
  paymentHistory,
  includeStoreCredit = true
) => {
  let sum =
    paymentHistory.totalPaidAmount[transactionConstants.CASH] +
    paymentHistory.totalPaidAmount[transactionConstants.CREDIT_CARD] +
    paymentHistory.totalPaidAmount[transactionConstants.GIFT_CARD] +
    (paymentHistory.totalPaidAmount[transactionConstants.OTHER] || 0);

  if (includeStoreCredit) {
    sum += paymentHistory.totalPaidAmount[transactionConstants.STORE_CREDIT];
  }

  return parseToNumber(sum);
};

export const subtotal = (inventoryInfo) => {
  if (Array.isArray(inventoryInfo) && inventoryInfo.length > 0) {
    return inventoryInfo.reduce((acc, item) => {
      return acc + item.price * (item.quantity || 0);
    }, 0);
  }
  return "0.00";
};
export const calcullateItems = (inventoryInfo) => {
  if (Array.isArray(inventoryInfo) && inventoryInfo.length > 0) {
    return inventoryInfo.reduce((acc, item) => {
      return acc + getQuantityValue(item, true, true);
    }, 0);
  }
  return "0.00";
};

export const calculateTax = (subtotal, taxRate) => {
  return (subtotal * taxRate) / 100;
};

export const convertToDecimalNumber = (
  amount,
  isString,
  isThousandSeparator = true,
  isWholeNumber = false,
  thousandSeparator = ","
) => {
  if (typeof amount === "string") {
    amount = amount.replace(new RegExp(`\\${thousandSeparator}`, "g"), "");
  }

  let number = Number(amount) || 0;

  let formattedNumber = number.toFixed(2);

  if (isWholeNumber) {
    formattedNumber = number.toFixed(0);
  }

  let [integerPart, decimalPart] = formattedNumber.split(".");

  if (isThousandSeparator) {
    integerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      thousandSeparator
    );
  }

  let result = isWholeNumber ? integerPart : `${integerPart}.${decimalPart}`;

  return isString ? result : Number(result);
};

//------- parseToNumber
export const parseToNumber = (number) => {
  return convertToDecimalNumber(number, false, false);
};

//------- parseToDecimalNumber
export const parseToDecimalNumber = (number) => {
  return convertToDecimalNumber(number, true, false);
};

//------- parseToThousandSeperatorDecimalNumber
export const parseToThousandSeperatorDecimalNumber = (number) => {
  return convertToDecimalNumber(number, true, true);
};

export const parseToWholeNumber = (number) => {
  return convertToDecimalNumber(number, true, false, true);
};

//------- parseToThousandSeperatorWholeNumber
export const parseToThousandSeperatorWholeNumber = (number) => {
  return convertToDecimalNumber(number, true, true, true);
};

//-------highlight table selected row on double click
export const handleHighlightSelectedRow = (row) => {
  let selectedRow = document.getElementById("row-" + row.id);
  if (selectedRow) {
    selectedRow.classList.add("editable-table-selected-row");
  }
};

//-------De Highlight table selected row on double click
export const handleDehighlightSelectedRow = (selectedRowId) => {
  // removing edit styles of previous record if any
  let deSelectRow = document.getElementById("row-" + selectedRowId);
  if (deSelectRow) {
    deSelectRow.classList.remove("editable-table-selected-row");
  }
};

// Function to convert epoch format to standard date
export const standardDate = (value) => {
  return value ? moment.unix(value).format(DATE_FORMAT.DATE) : "";
};

export function calculateDuration(startDate, endDate) {
  const currentDateTime = moment();

  if (endDate === globalConstants.DEFAULT_ENDDATE) {
    return "-";
  }

  // const start = moment(startDate);
  const end = moment(endDate);
  if (end.isBefore(currentDateTime, "day")) {
    return discountConstants.DISCOUNT_EXPIRED;
  }

  let duration = moment.duration(end.diff(currentDateTime));

  let result = "";

  const years = duration.years();
  const months = duration.months();
  const days = duration.days();
  const hours = duration.hours();
  const minutes = duration.minutes(); // Get remaining minutes

  const weeks = Math.floor(days / 7);
  const daysLeft = days % 7;

  if (years > 0) {
    result += years + " year" + (years > 1 ? "s" : "") + " ";
  }

  if (months > 0) {
    result += months + " month" + (months > 1 ? "s" : "") + " ";
  }

  if (weeks > 0) {
    result += weeks + " week" + (weeks > 1 ? "s" : "") + " ";
  }

  if (daysLeft > 0) {
    result += daysLeft + " day" + (daysLeft > 1 ? "s" : "") + " ";
  }

  if (hours > 0) {
    // Add this condition to include hours in the result
    result += hours + " hour" + (hours > 1 ? "s" : "") + " ";
  }
  if (minutes > 0) {
    result += minutes + " minute" + (minutes > 1 ? "s" : "") + " "; // Include remaining minutes in the result
  }

  result += "left";

  return result.trim();
}

export const handleKeyDown = (e) => {
  if (["e", "E", "+", "."].includes(e.key)) {
    e.preventDefault();
  }
  if (e.key !== "Backspace" && e.target.value.length === 7) {
    e.preventDefault();
  }
};
export const getUnitPurchasePrice = (newTradeData, cartItem) => {
  if (
    (newTradeData.paymentHistory?.[transactionConstants.CASH] || 0) +
      (newTradeData.paymentHistory?.[transactionConstants.STORE_CREDIT] || 0) +
      (newTradeData.paymentHistory?.[transactionConstants.OTHER] || 0) >
      0 &&
    newTradeData.currentAmountToPay !== newTradeData.totalAmountToPay
  ) {
    return convertToFixedPrecision(
      (cartItem.price.purchasePricePercentageEachItem *
        newTradeData.totalAmountToPay) /
        100 /
        cartItem.price.quantity
    );
  } else {
    if (
      newTradeData.userPaymentType === globalConstants.CASH ||
      newTradeData.userPaymentType === globalConstants.OTHER
    ) {
      return cartItem?.cashOffer;
    } else {
      return cartItem?.tradeOffer;
    }
  }
};

export const handleViewTCGPlayer = (productDataObject) => {
  if (productDataObject?.tcgPlayerUrl) {
    window.open(productDataObject.tcgPlayerUrl, "_blank");
  }
};

export const handleViewPriceCharting = (
  priceChartingProductInfo,
  setProductUrl
) => {
  if (priceChartingProductInfo) {
    setProductUrl(
      `${process.env.REACT_APP_PRICECHARTING_IFRAME_URL}${stringToSlug(
        priceChartingProductInfo?.productObject["console-name"]
      )}/${stringToSlug(
        priceChartingProductInfo?.productObject["product-name"]
      )}`
    );
  }
};

export const handleViewEbaySales = (productName, consoleName, subCategory) => {
  if (productName && consoleName) {
    let name = productName.split(" ").join("+");
    if (subCategory && subCategory === "Systems") {
      name = name;
    } else {
      name =
        productName.split(" ").join("+") +
        "+" +
        consoleName.split(" ").join("+");
    }

    name = encodeQueryParam(name, "&");

    const productUrl = `${process.env.REACT_APP_EBAY_IFRAME_URL}${name}&_ipg=200&LH_Sold=1`;
    window.open(productUrl, "_blank");
  }
};

export const getPricechartingProductImage = (
  productUrl,
  setPricechartingProductImage
) => {
  return inventoryService
    .getPricechartingProductImage({ url: productUrl })
    .then(
      (response) => {
        if (
          response &&
          typeof response === "string" &&
          response.includes("https")
        ) {
          setPricechartingProductImage(response);
        } else {
          setPricechartingProductImage("");
        }
      },
      (error) => {}
    );
};

export const batchPricechartingProductImage = (priceChartingProductInfo) => {
  return inventoryService
    .getPricechartingProductImage({
      url: `${process.env.REACT_APP_PRICECHARTING_IFRAME_URL}${stringToSlug(
        priceChartingProductInfo?.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
        ]
      )}/${stringToSlug(
        priceChartingProductInfo?.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_NAME
        ]
      )}`,
    })
    .then(
      (response) => {
        return response;
      },
      (error) => {}
    );
};

export const uploadCustomProductImage = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return storeService.uploadLogo(formData).then(
    (response) => {
      return response?.data?.data;
    },
    (error) => {
      customToast(error, toastType.ERROR);
    }
  );
};

export const handleEmptyOnFocus = (e) => {
  if (e.target.value === "0" || e.target.value === "0.00") {
    e.target.value = "";
  }
};

export const handleZeroOnBlur = (e, value, onChangeFunction) => {
  if (e.target.value === "") {
    e.target.value = parseToNumber(value);
    onChangeFunction(parseToNumber(value));
  }
};

//------match tags of a poduct
export const isTagsEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false;
    }
  }
  return true;
};

//------update batch inventory array
export const updateBatchInventoryList = async (
  currentStore,
  inventoryActions,
  addBatchInventory,
  temporaryProductDataObject,
  setAddBatchInventory,
  markupPresets,
  handlePercentageFlag,
  scrollToTop
) => {
  const productsInInventory = await inventoryActions.getInventoryProducts(
    currentStore?.id,
    {
      id: temporaryProductDataObject.productId,
      categoryName: temporaryProductDataObject.consoleName,
      productName: temporaryProductDataObject.productName,
    }
  );

  if (productsInInventory?.length > 0) {
    temporaryProductDataObject = {
      ...temporaryProductDataObject,
      productsAvailableInInventory: productsInInventory,
    };
  }

  temporaryProductDataObject = {
    ...temporaryProductDataObject,
    inStockPrice: getInStockPrice(temporaryProductDataObject, markupPresets),
  };

  temporaryProductDataObject = {
    ...temporaryProductDataObject,
    imgUrl:
      productsInInventory[0]?.imgUrl ||
      (await batchPricechartingProductImage({
        productObject: {
          "console-name": temporaryProductDataObject.consoleName,
          "product-name": temporaryProductDataObject.productName,
        },
      })),
  };
  setAddBatchInventory(
    handlePercentageFlag([
      ...addBatchInventory,
      {
        ...temporaryProductDataObject,
      },
    ])
  );

  // // Duplicate product is not allowed
  // if (temporaryProductDataObject.productId) {
  //   const isProductDuplicate = isProductExistInBatchList(
  //     addBatchInventory,
  //     temporaryProductDataObject
  //   );

  //   if (!isProductDuplicate) {
  //     setAddBatchInventory([
  //       ...addBatchInventory,
  //       {
  //         ...temporaryProductDataObject,
  //       },
  //     ]);
  //   } else {
  //     const updatedInventory = addBatchInventory.map((item) =>
  //       isProductExistInBatchList([item], temporaryProductDataObject)
  //         ? { ...item, inStockQuantity: item.inStockQuantity + 1 }
  //         : item
  //     );
  //     // customToast("Duplicate product is not allowed", toastType.ERROR);
  //     setAddBatchInventory([...updatedInventory]);
  //   }
  // }
  scrollToTop();
};

export const getInStockProducts = async (
  currentStore,
  inventoryActions,
  addBatchInventory,
  setAddBatchInventory,
  markupPresets,
  handlePercentageFlag,
  tradeinMargin,
  shopifySettings,
  isTrade = false
) => {
  try {
    // Iterate through each item in the batch inventory
    const updatedBatchInventory = await Promise.all(
      addBatchInventory.map(async (item) => {
        if (item.isDataFetching) {
          if (item.apiSource === inventoryConstants.STORE_CUSTOM_PRODUCT) {
            // Fetch product data only if isDataFetching is true
            const productsInInventory =
              await inventoryActions.getStoreCustomProducts(currentStore?.id, {
                product_name: item.productName,
                category_name: item.consoleName,
                subcategory: item.genre || EMPTY_STRING,
                type: item.productCondition,
                tags: item.tags,
                cardRarity: item.cardRarity || EMPTY_STRING,
                productType: item.productType,
                serialNumber: EMPTY_STRING,
                grade: item.grade || item?.price?.grade || EMPTY_STRING,
              });
            var tradeInMarginToApply = getMarginDropdownValue(
              item.marketPrice,
              tradeinMargin,
              item.productType,
              {
                ...item,
                tags: item.tags,
                condition: item.productCondition,
                cardRarity: item.cardRarity || EMPTY_STRING,
                subcategory: item.subcategory,
              }
            );

            // If products are found in the inventory, update the item
            if (productsInInventory?.length > 0) {
              item.productsAvailableInInventory = productsInInventory;
              item.imgUrl =
                productsInInventory[0]?.imgUrl || item.imgUrl || EMPTY_STRING;

              const marketPriceAfterPreset = getMarketPriceAfterPreset(
                currentStore,
                item,
                markupPresets
              );

              const calculateCOG = (price) => {
                const { cashOffer } = calculateOfferPrices(
                  price,
                  tradeInMarginToApply.marginObject,
                  tradeInMarginToApply?.marginObject?.cashMarginPercentage,
                  tradeInMarginToApply?.marginObject?.tradeinMarginPercentage
                );
                return parseToDecimalNumber(cashOffer);
              };

              let tempValuesMappedAsPerExisting =
                handlePrepareProductDataObject(
                  item,
                  productsInInventory[0],
                  productsInInventory,
                  shopifySettingsObject,
                  item.productType,
                  item.marketPrice,
                  markupPresets,
                  calculateCOG,
                  marketPriceAfterPreset
                );
              item = {
                ...item,
                ...tempValuesMappedAsPerExisting,
                inStockQuantity: 1,
              };
            }
            item.tradeInMarginTypeObject = tradeInMarginToApply;
          } else {
            // Fetch product data only if isDataFetching is true
            const productsInInventory =
              await inventoryActions.getInventoryProducts(currentStore?.id, {
                id: item.productId,
                categoryName: item.consoleName,
                productName: item.productName,
              });

            // If products are found in the inventory, update the item
            if (productsInInventory?.length > 0) {
              item.productsAvailableInInventory = productsInInventory;
            }

            const isProductExist = findExistingStockProduct(item);

            if (isProductExist?.length) {
              var shopifySettingsObject = getDefaultShopifySettings(
                item.marketPrice,
                shopifySettings,
                item.productType,
                {
                  ...item,
                  tags: item.tags,
                  condition: item.productCondition,
                  cardRarity: item.cardRarity || EMPTY_STRING,
                  subcategory: getProductSubCategory(item.genre),
                }
              );

              item = {
                ...item,
                ...handlePrepareProductDataObject(
                  item,
                  isProductExist[0],
                  isProductExist,
                  shopifySettingsObject,
                  item.productType,
                  item.marketPrice,
                  markupPresets,
                  () => {}, //cash offer and trade offer is calculated after this
                  0
                ),
              };
            }

            item.inStockPrice = getInStockPrice(item, markupPresets);
            item.inStockQuantity = 1; //in batch table row inStockQuantity represent product.price.quantity
            item.onlineUnitSellPrice = item.onlineUnitSellPrice
              ? item.onlineUnitSellPrice
              : item.inStockPrice;
            // item.costOfGoods = getInStockPrice(item, markupPresets, true);

            var tradeInMarginToApply = getMarginDropdownValue(
              item.marketPrice,
              tradeinMargin,
              item.productType,
              {
                ...item,
                tags: item.tags,
                condition: item.productCondition,
                cardRarity: item.cardRarity || EMPTY_STRING,
                subcategory: getProductSubCategory(item.genre),
              }
            );
            const isUseStockPrice =
              currentStore[
                toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
              ];
            const marketPriceAfterPreset = currentStore?.[
              toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
            ]
              ? getPresetStockPrice(
                  item.productType,
                  item.marketPrice,
                  markupPresets,
                  item
                )
              : item.marketPrice;

            const { cashOffer, tradeOffer } = calculateOfferPrices(
              marketPriceAfterPreset,
              tradeInMarginToApply.marginObject,
              tradeInMarginToApply.marginObject.cashMarginPercentage,
              tradeInMarginToApply.marginObject.tradeinMarginPercentage
            );
            if (isTrade) {
              item.cashOffer = cashOffer;
              item.tradeOffer = tradeOffer;
            } else {
              item.costOfGoods = cashOffer;
            }

            // Set the product image, fallback to an API if it's not available
            item.imgUrl =
              productsInInventory[0]?.imgUrl ||
              item.imgUrl ||
              (await batchPricechartingProductImage({
                productObject: {
                  "console-name": item.consoleName,
                  "product-name": item.productName,
                },
              }));
          }
          // Set isDataFetching to false once the data has been fetched
          item.isDataFetching = false;
        }
        return item; // Return the updated item or unchanged item
      })
    );

    // Once all items are processed, update the state
    setAddBatchInventory(handlePercentageFlag(updatedBatchInventory));
  } catch (error) {
    console.error("Error fetching in-stock products:", error);
    // Optionally, you can handle errors here, like setting a loading state or an error message
  }
};

//------update batch inventory array
export const addProductInBatch = async (
  currentStore,
  inventoryActions,
  addBatchInventory,
  temporaryProductDataObject,
  setAddBatchInventory,
  markupPresets,
  handlePercentageFlag,
  scrollToTop
) => {
  setAddBatchInventory(
    handlePercentageFlag([
      ...addBatchInventory,
      {
        ...temporaryProductDataObject,
        isDataFetching: true,
      },
    ])
  );
  scrollToTop();
};

//-------chech if product already exist
export const findExistingStockProduct = (row) => {
  let rowTags = row.tags?.map((tags) =>
    typeof tags === "object" && tags.hasOwnProperty("label")
      ? tags.label || EMPTY_STRING
      : tags
  ); //in case of custom products it was handled as array of object
  return isProductsExistInStock(
    row.productCondition,
    rowTags,
    row.cardRarity,
    row?.productsAvailableInInventory,
    row
  );
};

//------- Show stock price (sell or cogs) according to condition
export const getInStockPrice = (
  row,
  markupPresets,
  isCogs = false,
  isOnline = false
) => {
  const isProductExist = findExistingStockProduct(row);
  let updatedPrice = 0;
  // if (
  //   isProductExist &&
  //   isProductExist.price.unit_sell_price > row.marketPrice
  // ) {
  //   updatedMarketPrice = isProductExist.price.unit_sell_price;
  // } else {
  //   if (row.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD) {
  //     updatedMarketPrice = row.marketPrice;
  //   } else {
  //     if (row.productCondition === PRODUCT_CONDITIONS_ENUMS.COMPLETE) {
  //       updatedMarketPrice = row.suggestedSellPrice;
  //     } else if (row.productCondition === PRODUCT_CONDITIONS_ENUMS.LOOSE) {
  //       updatedMarketPrice = row.suggestedSellPriceLoose;
  //     } else if (row.productCondition === PRODUCT_CONDITIONS_ENUMS.NEW) {
  //       updatedMarketPrice = row.suggestedSellPriceNew;
  //     }
  //   }
  // }
  if (isProductExist?.length) {
    if (isOnline) {
      updatedPrice = isCogs
        ? isProductExist[0]?.price.unit_purchase_price
        : isProductExist[0]?.price.onlineUnitSellPrice;
    } else {
      updatedPrice = isCogs
        ? isProductExist[0]?.price.unit_purchase_price
        : isProductExist[0]?.price.unit_sell_price;
    }
  } else {
    updatedPrice = isCogs
      ? row.costOfGoods
      : getPresetStockPrice(
          row.productType,
          row.marketPrice,
          markupPresets,
          row
        );
  }

  return parseToDecimalNumber(updatedPrice);
};

//-------get product from inventory if exist
export const getProductIfExist = (row, onChangeStockPrice) => {
  const isProductExist = findExistingStockProduct(row);

  if (isProductExist?.length) {
    return (
      <span className="lh-base fw-bold">
        {getTotalNumberOfInStockProducts(
          isProductExist,
          row?.isSeparateQuantity
        )}{" "}
        in stock at{" "}
        <span
          className="text-decoration-underline  cursor-pointer"
          onClick={() =>
            onChangeStockPrice(
              parseToDecimalNumber(
                row?.isSeparateQuantity && row?.isOnlineUnitSellPrice
                  ? isProductExist[0].price.onlineUnitSellPrice
                  : isProductExist[0].price.unit_sell_price
              ),
              row.id
            )
          }
        >
          $
          {parseToThousandSeperatorDecimalNumber(
            row?.isSeparateQuantity && row?.isOnlineUnitSellPrice
              ? isProductExist[0].price.onlineUnitSellPrice
              : isProductExist[0].price.unit_sell_price
          )}
        </span>
      </span>
    );
  } else {
    return <span className="lh-base fw-bold">No Stock Found.</span>;
  }
};

export const findProductByCondition = (
  products,
  condition,
  selectedTags,
  selectedRarity,
  apiSource,
  product_name,
  category_name,
  productType
) => {
  if (products?.length > 0) {
    return products.find((product) => {
      if (
        (product?.price?.type || product?.productCondition) === condition &&
        isTagsEqual(product.tags || [], selectedTags || []) &&
        (product?.product_name || product?.productName) === product_name &&
        (product?.category_name || product?.consoleName) === category_name &&
        product.productType === productType
      ) {
        if (
          apiSource === inventoryConstants.POKEMON_API ||
          apiSource === inventoryConstants.SCRYFALL_API
        ) {
          if (product.cardRarity === selectedRarity) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    });
  }
  return null;
};

export function matchString(string) {
  return string.substring(0, 7);
}

export const updateInventorySKU = (InventoryArray) => {
  const updatedInventory = InventoryArray.map((item) => {
    if (item.sku[0].includes(transactionConstants.BATCH_TRADE)) {
      return {
        ...item,
        sku: [transactionConstants.BATCH_TRADE],
      };
    } else if (item.sku[0].includes(transactionConstants.QUICK_TRADE)) {
      return {
        ...item,
        sku: [transactionConstants.QUICK_TRADE],
      };
    } else {
      return item; // Return the item unchanged if neither condition is met
    }
  });

  return updatedInventory;
};

//--- calculate the new online and in store cash and trade offers on change of either quantity
export const onChangeStockPrice = (
  newPrice,
  setFieldValue,
  marketPrice,
  initialGlobalRatio,
  marginTypeObject,
  currentStore,
  cashOfferKey = "cashOffer",
  markupPresets,
  productType,
  productDataObject,
  isOnlineUnitSellPrice = true,
  isSeparateQuantity = false
) => {
  let updatedPrices = {};
  newPrice = Number(newPrice);
  let cashMarginPercentage =
    initialGlobalRatio?.globalMarginObject?.cashMarginPercentage;
  let tradeinMarginPercentage =
    initialGlobalRatio?.globalMarginObject?.tradeinMarginPercentage;

  // const newMarketPrice = getPresetStockPrice(
  //   productType,
  //   marketPrice,
  //   markupPresets,
  //   productDataObject
  // );

  const newMarketPrice = currentStore?.[
    toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
  ]
    ? getPresetStockPrice(
        productType,
        marketPrice,
        markupPresets,
        productDataObject
      )
    : marketPrice;

  if (newPrice !== 0) {
    const priceToUse =
      marketPrice === 0 ||
      currentStore?.[
        toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
      ]
        ? newPrice
        : Math.min(newPrice, newMarketPrice);

    const { cashOffer, tradeOffer } = calculateOfferPrices(
      priceToUse,
      marginTypeObject?.marginObject,
      cashMarginPercentage ??
        marginTypeObject?.marginObject?.cashMarginPercentage,
      tradeinMarginPercentage ??
        marginTypeObject?.marginObject?.tradeinMarginPercentage
    );
    setFieldValue(cashOfferKey, cashOffer);

    if (isSeparateQuantity) {
      updatedPrices.onlineCashOffer = cashOffer;
      updatedPrices.onlineTradeOffer = tradeOffer;
      setFieldValue("onlineCashOffer", cashOffer);
      setFieldValue("onlineTradeOffer", tradeOffer);
    } else {
      updatedPrices.cashOffer = cashOffer;
      updatedPrices.tradeOffer = tradeOffer;
      setFieldValue("cashOffer", cashOffer);
      setFieldValue("tradeOffer", tradeOffer);
      if (!isOnlineUnitSellPrice) {
        updatedPrices.onlineCashOffer = cashOffer;
        updatedPrices.onlineTradeOffer = tradeOffer;
        setFieldValue("onlineCashOffer", cashOffer);
        setFieldValue("onlineTradeOffer", tradeOffer);
      }
    }
  }
  return updatedPrices;
};

export const convertPricesToNumbers = (prices) => {
  const result = {};

  for (const [key, value] of Object.entries(prices)) {
    const numericValue =
      value !== null && !isNaN(parseFloat(value)) ? parseFloat(value) : null;
    result[key] = numericValue;
  }

  return result;
};

//-------calculate price for missing manual (complete price can never be less than loose price)
const handleCalculatePriceForMissingManual = (
  productLoosePrice,
  productManualOnlyPrice,
  productPriceAfterDecrement,
  productsuggestedSellPriceDecrement
) => {
  let sellPrice = 0;
  let marketPrice = 0;
  const tempLoosePrice = Number(productLoosePrice);
  const tempSuggestedLoosePrice = Number(productLoosePrice);
  const tempManualDeductedPrice =
    Number(productPriceAfterDecrement) - Number(productManualOnlyPrice);
  const tempSuggestedManualDeductedPrice =
    Number(productsuggestedSellPriceDecrement) - Number(productManualOnlyPrice);
  const differenceBetweenSellPriceAndMarketPrice =
    Number(tempSuggestedManualDeductedPrice) - Number(tempManualDeductedPrice);

  marketPrice =
    tempManualDeductedPrice < tempLoosePrice
      ? tempLoosePrice
      : tempManualDeductedPrice;
  sellPrice =
    tempSuggestedManualDeductedPrice < tempSuggestedLoosePrice
      ? tempSuggestedLoosePrice + differenceBetweenSellPriceAndMarketPrice
      : tempSuggestedManualDeductedPrice;
  return {
    marketPrice: marketPrice || 0,
    sellPrice: sellPrice || 0,
  };
};

//------change price base on tags
export const changePriceBaseOnTags = (
  selectedTags,
  productDataObject,
  setProductDataObject,
  priceChartingProductInfo,
  inventoryConstants,
  PRODUCT_CONDITIONS_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
  productCondition,
  productType
) => {
  if (priceChartingProductInfo?.productObject) {
    let productMarketPrice = 0;
    let productSuggestedSellPrice = 0;
    if (productType === PRODUCT_TYPES_ENUMS.TRADING_CARD) {
      productMarketPrice = Number(productDataObject.marketPrice);
      productSuggestedSellPrice = Number(productDataObject?.suggestedSellPrice);
    } else {
      if (productCondition?.value === PRODUCT_CONDITIONS_ENUMS.COMPLETE) {
        productMarketPrice =
          priceChartingProductInfo.productObject[
            inventoryConstants.COMPLETE_IN_BOX_PRICE
          ] || 0;
        productSuggestedSellPrice =
          priceChartingProductInfo?.productObject[
            inventoryConstants.RETAIL_COMPLETE_IN_BOX_PRICE
          ] || 0;
      } else if (productCondition?.value === PRODUCT_CONDITIONS_ENUMS.LOOSE) {
        productMarketPrice =
          priceChartingProductInfo.productObject[
            inventoryConstants.LOOSE_PRICE
          ] || 0;
        productSuggestedSellPrice =
          priceChartingProductInfo?.productObject[
            inventoryConstants.RETAIL_LOOSE_PRICE
          ] || 0;
      } else if (
        productCondition?.value === PRODUCT_CONDITIONS_ENUMS.BOX_ONLY
      ) {
        productMarketPrice =
          priceChartingProductInfo.productObject[
            inventoryConstants.BOX_ONLY_PRICE
          ] || 0;
      } else if (productCondition?.value === PRODUCT_CONDITIONS_ENUMS.NEW) {
        productMarketPrice =
          priceChartingProductInfo.productObject[
            inventoryConstants.NEW_PRICE
          ] || 0;
        productSuggestedSellPrice =
          priceChartingProductInfo?.productObject[
            inventoryConstants.RETAIL_NEW_PRICE
          ] || 0;
      } else if (
        productCondition?.value === PRODUCT_CONDITIONS_ENUMS.MANUAL_ONLY
      ) {
        productMarketPrice =
          priceChartingProductInfo.productObject[
            inventoryConstants.MANUAL_ONLY_PRICE
          ] || 0;
      }
    }
    let productBoxOnlyPrice =
      priceChartingProductInfo.productObject[
        inventoryConstants.BOX_ONLY_PRICE
      ] || 0;
    let productManualOnlyPrice = Number(
      priceChartingProductInfo.productObject[
        inventoryConstants.MANUAL_ONLY_PRICE
      ] || 0
    );
    let damaged = 0;
    let missingWires = false;
    let missingController = false;
    let box = false;
    let missingManual = false;
    let withManual = false;

    if (selectedTags) {
      if (selectedTags.includes(inventoryConstants.PRODUCT_TAGS.DAMAGED)) {
        damaged = inventoryConstants.DAMAGED_PERCENTAGE;
      }
      if (
        selectedTags.includes(inventoryConstants.PRODUCT_TAGS.MISSING_WIRES)
      ) {
        missingWires = true;
      }
      if (
        selectedTags.includes(
          inventoryConstants.PRODUCT_TAGS.MISSING_CONTROLLER
        )
      ) {
        missingController = true;
      }
      if (selectedTags.includes(inventoryConstants.PRODUCT_TAGS.WITH_BOX)) {
        box = true;
      }
      if (
        selectedTags.includes(inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL)
      ) {
        missingManual = true;
      }
      if (selectedTags.includes(inventoryConstants.PRODUCT_TAGS.WITH_MANUAL)) {
        withManual = true;
      }

      const productLoosePrice =
        priceChartingProductInfo.productObject[inventoryConstants.LOOSE_PRICE];

      const missingWiresDeduction =
        inventoryConstants.MISSING_WIRES_PERCENTAGE * productLoosePrice;
      const missingControllerDeduction =
        inventoryConstants.MISSING_CONTROLLER_PERCENTAGE * productLoosePrice;
      const totalDecreasePercentage = damaged;

      //-------Product Market Price after damaged percentage Decution
      let productPriceAfterDecrement =
        productMarketPrice - productMarketPrice * totalDecreasePercentage;

      //-------Product Suggested Sell Price after damaged percentage Decution
      let productsuggestedSellPriceDecrement =
        productSuggestedSellPrice -
        productSuggestedSellPrice * totalDecreasePercentage;

      //-------If with-manaul Tag is Selected Then Add Manual
      //-------Price in Product Market Price
      if (withManual) {
        productPriceAfterDecrement =
          productPriceAfterDecrement + productManualOnlyPrice;
        productsuggestedSellPriceDecrement =
          productsuggestedSellPriceDecrement + productManualOnlyPrice;
      }

      //-------If missing-Manaul Tag is Selected Then Deduct Manual
      //-------Price from Product Market Price
      if (missingManual) {
        let res = handleCalculatePriceForMissingManual(
          productLoosePrice,
          productManualOnlyPrice,
          productPriceAfterDecrement,
          productsuggestedSellPriceDecrement
        );
        productPriceAfterDecrement = res.marketPrice;
        productsuggestedSellPriceDecrement = res.sellPrice;
      }

      //-------If missing-wires Tag is Selected Then Deduct missing wires Percentage
      //-------Price from Product Market Price
      if (missingWires) {
        productPriceAfterDecrement =
          productPriceAfterDecrement - missingWiresDeduction;
        productsuggestedSellPriceDecrement =
          productsuggestedSellPriceDecrement - missingWiresDeduction;
      }

      //-------If missing-controller Tag is Selected Then Deduct missing controller Percentage
      //-------Price from Product Market Price
      if (missingController) {
        productPriceAfterDecrement =
          productPriceAfterDecrement - missingControllerDeduction;
        productsuggestedSellPriceDecrement =
          productsuggestedSellPriceDecrement - missingControllerDeduction;
      }

      //-------If Product is System and with-box tag is selected then
      //-------add price of box
      if (productDataObject.genre === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM) {
        if (box) {
          productPriceAfterDecrement =
            productPriceAfterDecrement + productBoxOnlyPrice;
          productsuggestedSellPriceDecrement =
            productsuggestedSellPriceDecrement + productBoxOnlyPrice;
        }
      }

      setProductDataObject({
        ...productDataObject,
        marketPrice: productPriceAfterDecrement,
        suggestedSellPrice: productsuggestedSellPriceDecrement,
      });
    } else {
      setProductDataObject({
        ...productDataObject,
        marketPrice: productMarketPrice,
        suggestedSellPrice: productSuggestedSellPrice,
      });
    }
  }
};

//------batch edit change price base on tags
export const batchEditChangePriceBaseOnTags = (
  selectedTagsList,
  productDataObject,
  setProductDataObject,
  productCondition,
  productType,
  tradeinMargin,
  markupPresets,
  isTradeBatch = false
) => {
  let response = {};

  if (productDataObject) {
    let productMarketPrice = 0;
    let productSuggestedSellPrice = 0;
    if (productType === PRODUCT_TYPES_ENUMS.TRADING_CARD) {
      productMarketPrice = Number(productDataObject.marketPrice);
      productSuggestedSellPrice = Number(productDataObject?.suggestedSellPrice);
    } else {
      const conditionPriceData =
        getMarketPriceBaseOnCondition(productDataObject);
      productMarketPrice =
        conditionPriceData[productCondition?.value]?.marketPrice;
      productSuggestedSellPrice =
        conditionPriceData[productCondition?.value]?.suggestedSellPrice;
    }

    let productBoxOnlyPrice = productDataObject?.boxOnlyPrice || 0;
    let productManualOnlyPrice = Number(productDataObject?.manualPrice || 0);
    let damaged = 0;
    let missingWires = false;
    let missingController = false;
    let box = false;
    let missingManual = false;
    let withManual = false;

    const selectedTags = selectedTagsList?.map((tag) => tag.label) || [];

    if (selectedTags) {
      if (selectedTags.includes(inventoryConstants.PRODUCT_TAGS.DAMAGED)) {
        damaged = inventoryConstants.DAMAGED_PERCENTAGE;
      }
      if (
        selectedTags.includes(inventoryConstants.PRODUCT_TAGS.MISSING_WIRES)
      ) {
        missingWires = true;
      }
      if (
        selectedTags.includes(
          inventoryConstants.PRODUCT_TAGS.MISSING_CONTROLLER
        )
      ) {
        missingController = true;
      }
      if (selectedTags.includes(inventoryConstants.PRODUCT_TAGS.WITH_BOX)) {
        box = true;
      }
      if (
        selectedTags.includes(inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL)
      ) {
        missingManual = true;
      }
      if (selectedTags.includes(inventoryConstants.PRODUCT_TAGS.WITH_MANUAL)) {
        withManual = true;
      }

      const productLoosePrice = productDataObject?.loosePrice;

      const missingWiresDeduction =
        inventoryConstants.MISSING_WIRES_PERCENTAGE * productLoosePrice;
      const missingControllerDeduction =
        inventoryConstants.MISSING_CONTROLLER_PERCENTAGE * productLoosePrice;
      const totalDecreasePercentage = damaged;

      //-------Product Market Price after damaged percentage Decution
      let productPriceAfterDecrement =
        productMarketPrice - productMarketPrice * totalDecreasePercentage;

      //-------Product Suggested Sell Price after damaged percentage Decution
      let productsuggestedSellPriceDecrement =
        productSuggestedSellPrice -
        productSuggestedSellPrice * totalDecreasePercentage;

      //-------If with-manaul Tag is Selected Then Add Manual
      //-------Price in Product Market Price
      if (withManual) {
        productPriceAfterDecrement =
          productPriceAfterDecrement + productManualOnlyPrice;
        productsuggestedSellPriceDecrement =
          productsuggestedSellPriceDecrement + productManualOnlyPrice;
      }

      //-------If missing-Manaul Tag is Selected Then Deduct Manual
      //-------Price from Product Market Price
      if (missingManual) {
        let res = handleCalculatePriceForMissingManual(
          productLoosePrice,
          productManualOnlyPrice,
          productPriceAfterDecrement,
          productsuggestedSellPriceDecrement
        );
        productPriceAfterDecrement = res.marketPrice;
        productsuggestedSellPriceDecrement = res.sellPrice;
      }

      //-------If missing-wires Tag is Selected Then Deduct missing wires Percentage
      //-------Price from Product Market Price
      if (missingWires) {
        productPriceAfterDecrement =
          productPriceAfterDecrement - missingWiresDeduction;
        productsuggestedSellPriceDecrement =
          productsuggestedSellPriceDecrement - missingWiresDeduction;
      }

      //-------If missing-controller Tag is Selected Then Deduct missing controller Percentage
      //-------Price from Product Market Price
      if (missingController) {
        productPriceAfterDecrement =
          productPriceAfterDecrement - missingControllerDeduction;
        productsuggestedSellPriceDecrement =
          productsuggestedSellPriceDecrement - missingControllerDeduction;
      }

      //-------If Product is System and with-box tag is selected then
      //-------add price of box
      if (productDataObject.genre === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM) {
        if (box) {
          productPriceAfterDecrement =
            productPriceAfterDecrement + productBoxOnlyPrice;
          productsuggestedSellPriceDecrement =
            productsuggestedSellPriceDecrement + productBoxOnlyPrice;
        }
      }

      const updatedItem = {
        ...productDataObject,
        marketPrice: productPriceAfterDecrement,
        suggestedSellPrice: productsuggestedSellPriceDecrement,
      };

      var tradeInMarginToApply = getMarginDropdownValue(
        productPriceAfterDecrement,
        tradeinMargin,
        updatedItem.productType,
        {
          ...updatedItem,
          tags: updatedItem.tags,
          condition: updatedItem.productCondition,
          cardRarity: updatedItem?.cardRarity || EMPTY_STRING,
          subcategory: getProductSubCategory(updatedItem.genre),
        }
      );
      const { cashOffer, tradeOffer } = calculateOfferPrices(
        updatedItem.marketPrice,
        tradeInMarginToApply.marginObject,
        tradeInMarginToApply.marginObject.cashMarginPercentage,
        tradeInMarginToApply.marginObject.tradeinMarginPercentage
      );

      if (isTradeBatch) {
        updatedItem.cashOffer = convertToFixedPrecision(cashOffer); // Update cashOffer in the updatedItem
        updatedItem.tradeOffer = convertToFixedPrecision(tradeOffer);
      } else {
        updatedItem.costOfGoods = convertToFixedPrecision(cashOffer); // Update cashOffer in the updatedItem
      }

      const existingProduct = findExistingStockProduct({
        ...updatedItem,
        tags: selectedTagsList,
      });
      updatedItem.tags = selectedTagsList;
      updatedItem.inStockPrice = existingProduct?.length
        ? existingProduct[0]?.price?.unit_sell_price
        : getPresetStockPrice(
            updatedItem.productType,
            updatedItem.marketPrice,
            markupPresets,
            updatedItem
          );
      updatedItem.onlineUnitSellPrice = existingProduct?.length
        ? existingProduct[0]?.price?.onlineUnitSellPrice
        : getPresetStockPrice(
            updatedItem.productType,
            updatedItem.marketPrice,
            markupPresets,
            updatedItem
          );

      response = updatedItem;
    } else {
      response = {
        ...productDataObject,
        marketPrice: productMarketPrice,
        suggestedSellPrice: productSuggestedSellPrice,
      };
    }
  }
  setProductDataObject(response);
  return response;
};

export const exportTagFunc = (tags) => {
  if (!tags) {
    return "";
  }
  return tags.join("; ").replaceAll("#", EMPTY_STRING);
};

export const importTagFunc = (tags) => {
  // clean custom tag
  const cleanTagsFunc = (tags) => {
    let customTagRegex = /^#?custom$/i;
    let isCustomTag = tags.some((tag) => customTagRegex.test(tag));

    // remove all custom tags (case insensitive)
    let filteredTags = tags.filter((tag) => {
      return !customTagRegex.test(tag);
    });

    if (isCustomTag) {
      filteredTags.unshift(inventoryConstants.CUSTOM_ITEM_TAG);
    }

    return filteredTags;
  };

  if (!tags) {
    return [];
  }
  // convert tag string to array
  let tagsArray = tags.replace(/(?<=^|; )\b(?=\S)/g, "#").split("; ");
  let cleanTagsArray = cleanTagsFunc(tagsArray);
  return cleanTagsArray;
};

export const importUpcFunc = (value) => {
  return String(value);
};

export const exportUpcFunc = (value) => {
  return String(value);
};

export const exportStringArrayFunc = (array) => {
  return array.join("; ");
};

export const importStringArrayFunc = (array) => {
  return array.split("; ");
};

export const handleEmailOrSMSMessage = (
  messageType,
  isEmail,
  values,
  transactionData,
  customToast,
  toastMessages,
  toastType,
  sendEmailOrSMS
) => {
  if (messageType === EMAIL_MESSAGE_TYPES.TRANSACTION_RECEIPT) {
    if (isEmail) {
      if (!emailRegex.test(values.email)) {
        customToast(toastMessages.VALID_EMAIL, toastType.ERROR);
      } else {
        sendEmailOrSMS({
          isEmail: true,
          isSms: false,
          email: values.email,
          metaData: { store: values.store, transactionId: transactionData?.id },
          type: messageType,
        });
      }
    } else {
      if (!phoneRegex.test(values.mobile)) {
        customToast(toastMessages.VALID_MOBILE, toastType.ERROR);
      } else {
        sendEmailOrSMS({
          isEmail: false,
          isSms: true,
          phoneNumber: (values.mobile || "")
            .replace(/[()\- ]/g, "")
            .replace(/^/, "+1"),
          metaData: { store: values.store, transactionId: transactionData?.id },
          type: messageType,
        });
      }
    }
  } else if (messageType === EMAIL_MESSAGE_TYPES.USER_REPORTED_ISSUE) {
    sendEmailOrSMS(
      {
        isEmail: true,
        isSms: false,
        email: process.env.REACT_APP_SUPPORT_EMAIL,
        metaData: {
          store: values.store,
          userName: values.fullname,
          userEmail: values.email,
          errorDescription: values.problem,
          errorScreenUrl: values.errorScreenUrl,
        },
        type: messageType,
      },
      EMAIL_MESSAGE_TYPES.USER_REPORTED_ISSUE
    );
  }
};

export const calculateOfferPrices = (
  marketPrice,
  tradeInMarginObject,
  cashMarginPercentage,
  tradeinMarginPercentage
) => {
  const marketPriceNum = parseToNumber(marketPrice);
  const cashMarginPercentageNum = parseToNumber(cashMarginPercentage);
  const tradeinMarginPercentageNum = parseToNumber(tradeinMarginPercentage);

  const ratio = tradeinMarginPercentageNum / cashMarginPercentageNum;
  // const marketCashOffer = parseToDecimalNumber(
  //   (marketPriceNum * cashMarginPercentageNum) / 100
  // );
  const marketTradeOffer = parseToDecimalNumber(
    (marketPriceNum * tradeinMarginPercentageNum) / 100
  );
  const cashOffer = parseToDecimalNumber(
    tradeInMarginObject?.productMarginSetBy ===
      tradeInDiscountConstant.FIXED_VALUE
      ? parseToDecimalNumber(cashMarginPercentage)
      : marketTradeOffer / ratio
  );
  const tradeOffer = parseToDecimalNumber(
    tradeInMarginObject?.productMarginSetBy ===
      tradeInDiscountConstant.FIXED_VALUE
      ? parseToDecimalNumber(tradeinMarginPercentage)
      : cashOffer * ratio
  );
  return { cashOffer, tradeOffer };
};

export const downloadImage = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error("Error downloading image:", error);
    return null;
  }
};

// Returns the shortest 6-digit SKU
export const getShortestSku = (skuArr) => {
  // validate skuArr
  if (
    skuArr === EMPTY_STRING ||
    (Array.isArray(skuArr) && skuArr.length === 0)
  ) {
    return skuArr;
  } else if (!Array.isArray(skuArr)) {
    return skuArr;
  }

  // filter 6 digit skus
  const sixDigitSkuArr = skuArr.filter((sku) => {
    return sku.length === 6;
  });
  // find shortest 6 digit sku
  let shortestSku = 0;
  if (sixDigitSkuArr.length) {
    shortestSku = sixDigitSkuArr[0];
    sixDigitSkuArr.forEach((sku) => {
      if (Number(sku) < Number(shortestSku)) {
        shortestSku = sku;
      }
    });
  } else if (skuArr.length) {
    shortestSku = skuArr[0];
    skuArr.forEach((sku) => {
      if (Number(sku) < Number(shortestSku)) {
        shortestSku = sku;
      }
    });
  } else {
    throw new Error("Invalid Sku");
  }

  return shortestSku;
};

export const isArraySame = (array1, array2) => {
  if (array1.sort().join(",") === array2.sort().join(",")) {
    return true;
  } else {
    return false;
  }
};

// check either the sku array has the any sku which has batch-trade-in in it
export const isBatchTradeSku = (skuArr) => {
  if (!skuArr) {
    return false;
  }
  return skuArr.some((sku) => sku.includes(transactionConstants.BATCH_TRADE));
};

// check either the sku array has the any sku which has quick-trade-in in it
export const isQuickTradeSku = (skuArr) => {
  if (!skuArr) {
    return false;
  }
  return skuArr.some((sku) => sku.includes(transactionConstants.QUICK_TRADE));
};

// check either the sku array has the any sku which has custom-item in it
export const isCustomSku = (skuArr) => {
  if (!skuArr) {
    return false;
  }
  return skuArr.some((sku) => sku.includes(inventoryConstants.CUSTOM_ITEM));
};

export const getCountOfTotalItems = (array, key) => {
  return array.reduce((acc, item) => acc + Number(item[key]), 0);
};

export const getCountOfTradeTotalItems = (array, key) => {
  return array.reduce((acc, item) => acc + Number(item.price[key]), 0);
};

export function resizeAndDarkenImageBlob(
  blob,
  threshold = 128,
  dpi = printerConstants.DEFAULT_DPI
) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();

    reader.onload = function () {
      var img = new Image();

      img.onload = function () {
        // Create canvas for the original image
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        // Set canvas size to match the image size
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;

        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0);

        // Get the ImageData from the canvas
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;

        // Convert each pixel to grayscale
        for (var i = 0; i < pixels.length; i += 4) {
          var red = pixels[i];
          var green = pixels[i + 1];
          var blue = pixels[i + 2];
          var grayscale = RGBToGrayScale(red, green, blue);

          // Set the RGB values to the grayscale value
          pixels[i] = grayscale; // Red
          pixels[i + 1] = grayscale; // Green
          pixels[i + 2] = grayscale; // Blue
          // Alpha (pixels[i + 3]) remains unchanged
        }

        // Put the modified ImageData back onto the canvas
        ctx.putImageData(imageData, 0, 0);

        // Calculate new dimensions based on image height
        let newWidth, newHeight;
        const scale = dpi / printerConstants.DEFAULT_DPI;
        if (canvas.height >= systemConstants.LABEL_IMAGE_WIDTH) {
          newWidth = systemConstants.LABEL_IMAGE_WIDTH * scale;
        } else {
          newWidth = systemConstants.LABEL_IMAGE_MAX_WIDTH * scale;
        }
        newHeight = (newWidth / canvas.width) * canvas.height;
        // Resize the image
        var tempCanvas = document.createElement("canvas");
        var tempCtx = tempCanvas.getContext("2d");

        tempCanvas.width = newWidth;
        tempCanvas.height = newHeight;

        tempCtx.drawImage(canvas, 0, 0, newWidth, newHeight);

        // Convert canvas to blob
        tempCanvas.toBlob(function (resizedBlob) {
          if (resizedBlob) {
            resolve(resizedBlob);
          } else {
            reject(new Error("Failed to convert canvas to blob"));
          }
        }, blob.type); // Maintain original image type
      };

      img.onerror = function () {
        reject(new Error("Failed to load image"));
      };

      img.src = reader.result;
    };

    reader.onerror = function () {
      reject(new Error("Failed to read file"));
    };

    reader.readAsDataURL(blob);
  });
}

// Function to convert RGB values to grayscale using Rec. 709 coefficients
function RGBToGrayScale(red, green, blue) {
  return (red * 6966 + green * 23436 + blue * 2366) >> 15;
}

//-------resize logo image for print on label or receipt design
export function resizeImageBlob(blob, newWidth = 200) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();

    reader.readAsDataURL(blob);

    reader.onload = function () {
      var img = new Image();

      img.src = reader.result;

      img.onload = function () {
        var aspectRatio = img.width / img.height;
        var newHeight = newWidth / aspectRatio;

        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        canvas.width = newWidth;
        canvas.height = newHeight;

        // Draw the image without altering its appearance
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        // Convert canvas back to blob
        canvas.toBlob(function (resizedBlob) {
          resolve(resizedBlob);
        }, blob.type); // Maintain original image type
      };
    };

    reader.onerror = function (error) {
      reject(error);
    };
  });
}

//-------set product in redux after getting
export const setDefaultProductDataObject = async (
  markupPresets,
  setRarities,
  currentStore,
  inventoryActions,
  productDataObject,
  addBatchInventory,
  setSelectedRarity,
  tradeinMargin,
  isAddBatchInventory,
  setProductDataObject,
  setAddBatchInventory,
  priceChartingProductInfo,
  handlePercentageFlag,
  scrollToTop,
  emptyPriceChartingProductObject,
  customTypes,
  shopifySettings
) => {
  let temporaryProductType = EMPTY_STRING;
  let temporaryProductDataObject = { ...productDataObject };
  let temporaryProductCategory = EMPTY_STRING;
  let temporaryProductCondition = EMPTY_STRING;
  let temporaryProductConditionList = EMPTY_STRING;
  if (
    priceChartingProductInfo.productMetaData.sourceApi ===
    inventoryConstants.PRICECHARTING_API
  ) {
    if (
      priceChartingProductInfo.productMetaData.genre ===
      TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
    ) {
      temporaryProductType = PRODUCT_TYPES_ENUMS.VIDEO_GAME;
      temporaryProductCondition = handleDefaultBatchCondition(
        priceChartingProductInfo.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
        ],
        inventoryConstants.VIDEO_GAME_SYSTEM_CONDITION,
        priceChartingProductInfo.productObject["genre"]
      );
      temporaryProductConditionList = handleBatchCondition(
        priceChartingProductInfo.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
        ],
        inventoryConstants.VIDEO_GAME_SYSTEM_CONDITION
      );
    } else {
      temporaryProductType = PRODUCT_TYPES_ENUMS.VIDEO_GAME;
      temporaryProductConditionList = handleBatchCondition(
        priceChartingProductInfo.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
        ],
        inventoryConstants.VIDEO_GAME_CONDITION
      );
      temporaryProductCondition = handleDefaultBatchCondition(
        priceChartingProductInfo.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
        ],
        inventoryConstants.VIDEO_GAME_CONDITION,
        priceChartingProductInfo.productObject["genre"]
      );
    }

    temporaryProductDataObject = {
      ...productDataObject,
      ...priceChartingProductInfo.productObject,
      ...priceChartingProductInfo.productMetaData,
      id: addBatchInventory.length,
      productName:
        priceChartingProductInfo.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_NAME
        ],
      consoleName: temporaryProductCategory
        ? temporaryProductCategory
        : priceChartingProductInfo.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
          ],
      marketPrice: convertToUsd(getSystemMarketPrice(priceChartingProductInfo)),
      suggestedSellPrice: convertToUsd(
        getSystemSuggestedMarketPrice(priceChartingProductInfo)
      ),
      suggestedSellPriceComplete: convertToUsd(
        priceChartingProductInfo.productObject[
          inventoryConstants.RETAIL_COMPLETE_IN_BOX_PRICE
        ]
      ),
      suggestedSellPriceLoose: convertToUsd(
        priceChartingProductInfo.productObject[
          inventoryConstants.RETAIL_LOOSE_PRICE
        ]
      ),
      suggestedSellPriceNew: convertToUsd(
        priceChartingProductInfo.productObject[
          inventoryConstants.RETAIL_NEW_PRICE
        ]
      ),
      gameStopBuyPrice: convertToUsd(
        priceChartingProductInfo.productObject[
          inventoryConstants.GAMESTOP_PRICE
        ]
      ),
      upc: priceChartingProductInfo.productObject.upc || EMPTY_STRING,
      genre: priceChartingProductInfo.productMetaData.genre,
      productId: priceChartingProductInfo.productObject.id,
      productType: temporaryProductType,
      productCondition: temporaryProductCondition,
      productConditionList: temporaryProductConditionList,
      completePrice: convertToUsd(
        priceChartingProductInfo.productObject[
          inventoryConstants.COMPLETE_IN_BOX_PRICE
        ]
      ),
      loosePrice: convertToUsd(
        priceChartingProductInfo.productObject[inventoryConstants.LOOSE_PRICE]
      ),
      newPrice: convertToUsd(
        priceChartingProductInfo.productObject[inventoryConstants.NEW_PRICE]
      ),
      boxOnlyPrice: convertToUsd(
        priceChartingProductInfo.productObject[
          inventoryConstants.BOX_ONLY_PRICE
        ]
      ),
      manualPrice: convertToUsd(
        priceChartingProductInfo.productObject[
          inventoryConstants.MANUAL_ONLY_PRICE
        ]
      ),
      networkAverageBuySellPrices: {
        ...getNetworkAvgBuySellPricesAccordingCondition(
          temporaryProductCondition,
          priceChartingProductInfo
        ),
      },
      apiSource: priceChartingProductInfo.productMetaData.sourceApi,
      cardRarityList: [],
      cardRarity: EMPTY_STRING,
      imgUrl: EMPTY_STRING,
      epid: priceChartingProductInfo.productObject.epid || EMPTY_STRING,
      tcgPlayerUrl: EMPTY_STRING,
    };
    setProductDataObject({ ...temporaryProductDataObject });
  } else if (
    priceChartingProductInfo.productMetaData.sourceApi ===
    inventoryConstants.TCG_PLAYER_API
  ) {
    temporaryProductDataObject = {
      ...priceChartingProductInfo.productObject,
      ...priceChartingProductInfo.productMetaData,
      id: addBatchInventory.length,
      productCondition:
        priceChartingProductInfo?.productMetaData?.productCondition?.value ??
        EMPTY_STRING,
    };
    setProductDataObject({ ...temporaryProductDataObject });
  } else if (
    priceChartingProductInfo.productMetaData.sourceApi ===
    inventoryConstants.STORE_CUSTOM_PRODUCT
  ) {
    temporaryProductDataObject = {
      ...productDataObject,
      id: addBatchInventory.length,
      productName: priceChartingProductInfo.productObject.product_name,
      consoleName: priceChartingProductInfo.productObject.category_name,
      upc: priceChartingProductInfo.productObject.upc || EMPTY_STRING,
      genre: priceChartingProductInfo.productObject.subcategory,
      productId: priceChartingProductInfo.productObject.product_id,
      productType: priceChartingProductInfo.productObject.productType,
      productCondition: priceChartingProductInfo.productObject.price.type,
      productConditionList:
        getCustomProductConditionList(
          getTypeOrCategoryIdByName(
            customTypes,
            priceChartingProductInfo.productObject.productType
          ),
          customTypes
        ) || [],
      marketPrice: priceChartingProductInfo.productObject.price.unit_sell_price,
      apiSource: priceChartingProductInfo.productMetaData["sourceApi"],
      cardRarityList: [],
      cardRarity: null,
      tcgPlayerUrl: EMPTY_STRING,
      epid: EMPTY_STRING,
      imgUrl: priceChartingProductInfo.productObject.imgUrl || EMPTY_STRING,
      costOfGoods:
        priceChartingProductInfo.productObject.price.unit_purchase_price,
      inStockPrice:
        priceChartingProductInfo.productObject.price.unit_sell_price,
      tags: priceChartingProductInfo.productObject.tags,
      trackQuantity: priceChartingProductInfo.productObject.trackQuantity,
    };
    setProductDataObject({ ...temporaryProductDataObject });
  }
  var tradeInMarginToApply = getMarginDropdownValue(
    temporaryProductDataObject.marketPrice,
    tradeinMargin,
    temporaryProductDataObject.productType,
    {
      ...temporaryProductDataObject,
      tags: temporaryProductDataObject.tags,
      condition: temporaryProductDataObject.productCondition,
      cardRarity: temporaryProductDataObject?.cardRarity || EMPTY_STRING,
      subcategory: isStoreCustomProduct(temporaryProductDataObject)
        ? temporaryProductDataObject.metaData.subcategory
        : getProductSubCategory(temporaryProductDataObject.genre),
    }
  );
  // if (
  //   temporaryProductDataObject?.apiSource !==
  //   inventoryConstants.STORE_CUSTOM_PRODUCT
  // ) {
  const { cashOffer, tradeOffer } = calculateOfferPrices(
    temporaryProductDataObject.marketPrice,
    tradeInMarginToApply.marginObject,
    tradeInMarginToApply?.marginObject?.cashMarginPercentage,
    tradeInMarginToApply?.marginObject?.tradeinMarginPercentage
  );

  if (isAddBatchInventory) {
    temporaryProductDataObject = {
      ...temporaryProductDataObject,
      tradeInMarginTypeObject: tradeInMarginToApply,
      costOfGoods: parseToDecimalNumber(cashOffer),
    };
  } else {
    temporaryProductDataObject = {
      ...temporaryProductDataObject,
      tradeInMarginTypeObject: tradeInMarginToApply,
      cashOffer: cashOffer,
      tradeOffer: tradeOffer,
    };
  }
  // } else {
  //   temporaryProductDataObject = {
  //     ...temporaryProductDataObject,
  //     tradeInMarginTypeObject: tradeInMarginToApply,
  //   };
  // }

  var shopifySettingsObject = getDefaultShopifySettings(
    temporaryProductDataObject.marketPrice,
    shopifySettings,
    temporaryProductDataObject.productType,
    {
      ...temporaryProductDataObject,
      tags: temporaryProductDataObject.tags,
      condition: temporaryProductDataObject.productCondition,
      cardRarity: temporaryProductDataObject?.cardRarity || EMPTY_STRING,
      subcategory: isStoreCustomProduct(temporaryProductDataObject)
        ? temporaryProductDataObject.metaData.subcategory
        : getProductSubCategory(temporaryProductDataObject.genre),
    }
  );

  //------ Shopify Preset Configs
  const isLinkToShopify = shopifySettingsObject?.marginObject?.isLinkToShopify;
  const isOnlineQuantity =
    shopifySettingsObject?.marginObject?.isOnlineQuantity;
  const shopifySettingId = shopifySettingsObject?.marginObject?.id;
  const isOnlineUnitSellPrice =
    shopifySettingsObject?.marginObject?.isOnlineUnitSellPrice;
  temporaryProductDataObject = {
    ...temporaryProductDataObject,
    isSeparateQuantity: false,
    isLinkToShopify: isLinkToShopify,
    isOnlineQuantity: isOnlineQuantity,
    isOnlineUnitSellPrice: isOnlineUnitSellPrice,
    shopifySettingsObject: shopifySettingsObject,
    shopifySettingId: shopifySettingId,
  };

  addProductInBatch(
    currentStore,
    inventoryActions,
    addBatchInventory,
    temporaryProductDataObject,
    setAddBatchInventory,
    markupPresets,
    handlePercentageFlag,
    scrollToTop
  );
  emptyPriceChartingProductObject();
};

//-------get product stock price
export const getTradingCardStockPrice = (item, selectedOption) => {
  const existingCardProduct = findExistingStockProduct(item);

  if (
    existingCardProduct?.length &&
    existingCardProduct[0].price.unit_sell_price > selectedOption?.value?.value
  ) {
    return parseToDecimalNumber(existingCardProduct[0].price.unit_sell_price);
  } else {
    return parseToDecimalNumber(selectedOption?.value?.value);
  }
};

//-------handle rarity on change
export const handleRaritiesChange = (
  Id,
  selectedOption,
  addBatchInventory,
  setAddBatchInventory,
  tradeinMargin,
  isTradeBatch = false,
  markupPresets
) => {
  if (selectedOption) {
    // Find the item to update
    const itemToUpdate = addBatchInventory.find((item) => item.id === Id);

    if (itemToUpdate) {
      // Parse marketPrice from the selected option
      const marketPrice = parseToNumber(selectedOption?.value?.value);

      // Update the item directly
      itemToUpdate.cardRarity = selectedOption;
      itemToUpdate.tags = [];
      itemToUpdate.marketPrice = marketPrice;

      const tradeInMarginToApply = getMarginDropdownValue(
        marketPrice,
        tradeinMargin,
        itemToUpdate.productType,
        {
          ...itemToUpdate,
          tags: itemToUpdate.tags,
          condition: itemToUpdate.productCondition,
          cardRarity: itemToUpdate?.cardRarity || EMPTY_STRING,
          subcategory: getProductSubCategory(itemToUpdate.genre),
        }
      );
      const { cashOffer, tradeOffer } = calculateOfferPrices(
        marketPrice,
        tradeInMarginToApply.marginObject,
        tradeInMarginToApply.marginObject.cashMarginPercentage,
        tradeInMarginToApply.marginObject.tradeinMarginPercentage
      );

      if (isTradeBatch) {
        itemToUpdate.cashOffer = convertToFixedPrecision(cashOffer);
        itemToUpdate.tradeOffer = convertToFixedPrecision(tradeOffer);
      } else {
        itemToUpdate.costOfGoods = convertToFixedPrecision(cashOffer);
      }

      itemToUpdate.inStockPrice = getInStockPrice(itemToUpdate, markupPresets);

      // Since we're directly modifying the object, create a new array to trigger a re-render
      setAddBatchInventory([...addBatchInventory]);
    }
  }
};

//-------handle onchnage of product condition
export const onChangeProductCondition = (
  markupPresets,
  Id,
  newCondition,
  isTradeBatch,
  addBatchInventory,
  setAddBatchInventory,
  tradeinMargin
) => {
  // Find the item to be updated
  const itemToUpdate = addBatchInventory.find((item) => item.id === Id);

  if (itemToUpdate) {
    if (itemToUpdate?.apiSource === inventoryConstants.STORE_CUSTOM_PRODUCT) {
      itemToUpdate.productCondition = newCondition;
    } else {
      // Update productCondition and calculate marketPrice
      itemToUpdate.condition = newCondition;
      itemToUpdate.productCondition = newCondition;
      itemToUpdate.suggestedSellPrice = 0;
      itemToUpdate.tags = [];

      const conditionData =
        itemToUpdate.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD
          ? getTradingCardMarketPriceForSelectedProperties(
              itemToUpdate,
              itemToUpdate.language,
              newCondition,
              itemToUpdate.cardRarity,
              true
            )
          : getMarketPriceBaseOnCondition(itemToUpdate);
      const marketPrice = conditionData[newCondition]?.marketPrice;
      itemToUpdate.marketPrice = marketPrice;
      itemToUpdate.suggestedSellPrice =
        conditionData[newCondition]?.suggestedSellPrice;

      // Calculate offers based on marketPrice
      const tradeInMarginToApply = getMarginDropdownValue(
        marketPrice,
        tradeinMargin,
        itemToUpdate.productType,
        {
          ...itemToUpdate,
          tags: itemToUpdate.tags,
          condition: itemToUpdate.productCondition,
          cardRarity: itemToUpdate?.cardRarity || EMPTY_STRING,
          subcategory: getProductSubCategory(itemToUpdate.genre),
        }
      );
      const { cashOffer, tradeOffer } = calculateOfferPrices(
        marketPrice,
        tradeInMarginToApply.marginObject,
        tradeInMarginToApply.marginObject.cashMarginPercentage,
        tradeInMarginToApply.marginObject.tradeinMarginPercentage
      );

      if (isTradeBatch) {
        itemToUpdate.cashOffer = parseToDecimalNumber(cashOffer);
        itemToUpdate.tradeOffer = parseToDecimalNumber(tradeOffer);
        itemToUpdate.onlineCashOffer = parseToDecimalNumber(cashOffer);
        itemToUpdate.onlineTradeOffer = parseToDecimalNumber(tradeOffer);
      } else {
        itemToUpdate.costOfGoods = parseToDecimalNumber(cashOffer);
        itemToUpdate.onlineUnitPurchasePrice = parseToDecimalNumber(cashOffer);
      }
      itemToUpdate.inStockPrice = getInStockPrice(itemToUpdate, markupPresets);
      itemToUpdate.onlineUnitSellPrice = getInStockPrice(
        itemToUpdate,
        markupPresets,
        false,
        true
      );
    }

    if (itemToUpdate?.productsAvailableInInventory?.length) {
      const matchedProducts = isProductsExistInStock(
        newCondition,
        itemToUpdate.tags,
        itemToUpdate.cardRarity,
        itemToUpdate.productsAvailableInInventory,
        itemToUpdate
      );
      const matchedProduct = matchedProducts?.[0];
      itemToUpdate.variantId = matchedProduct?.variantId || EMPTY_STRING;
      itemToUpdate.shopifyInventoryItemId =
        matchedProduct?.shopifyInventoryItemId || EMPTY_STRING;
      if (matchedProduct?.shopifyId) {
        itemToUpdate.shopifyId = matchedProduct.shopifyId;
      }
    }

    setAddBatchInventory([...addBatchInventory]);
  }
};

//-------handle onchnage of product condition
export const handleBulkConditionChange = (
  markupPresets,
  newCondition,
  bulkUpdateItemIds,
  isTradeBatch,
  addBatchInventory,
  setAddBatchInventory,
  tradeinMargin,
  handleBatchInventoryPercentage
) => {
  const updatedInventory = addBatchInventory.map((item) => {
    let marketPrice = item.marketPrice; // Initialize marketPrice outside the if block

    if (
      bulkUpdateItemIds.includes(item.id) &&
      item.productCondition !== newCondition
    ) {
      // Update productCondition and calculate marketPrice
      const productConditions = item.productConditionList.map((i) => i.value);

      const updatedItem = {
        ...item,
        productCondition: productConditions.includes(newCondition)
          ? newCondition
          : item.productCondition,
        tags: [],
      };

      marketPrice =
        newCondition === PRODUCT_CONDITIONS_ENUMS.COMPLETE
          ? item?.completePrice ?? 0
          : newCondition === PRODUCT_CONDITIONS_ENUMS.LOOSE
          ? item?.loosePrice ?? 0
          : newCondition === PRODUCT_CONDITIONS_ENUMS.NEW
          ? item?.newPrice ?? 0
          : newCondition === PRODUCT_CONDITIONS_ENUMS.BOX_ONLY
          ? item?.boxOnlyPrice ?? 0
          : newCondition === PRODUCT_CONDITIONS_ENUMS.MANUAL_ONLY
          ? item?.manualPrice ?? 0
          : item?.marketPrice ?? 0;

      updatedItem.marketPrice = marketPrice;

      var tradeInMarginToApply = getMarginDropdownValue(
        marketPrice,
        tradeinMargin,
        updatedItem.productType,
        {
          ...updatedItem,
          tags: updatedItem.tags,
          condition: updatedItem.productCondition,
          cardRarity: updatedItem?.cardRarity || EMPTY_STRING,
          subcategory: getProductSubCategory(updatedItem.genre),
        }
      );

      // Calculate offers based on marketPrice
      const { cashOffer, tradeOffer } = calculateOfferPrices(
        marketPrice,
        tradeInMarginToApply.marginObject,
        tradeInMarginToApply?.marginObject.cashMarginPercentage,
        tradeInMarginToApply?.marginObject.tradeinMarginPercentage
      );

      if (isTradeBatch) {
        updatedItem.cashOffer = convertToFixedPrecision(cashOffer); // Update cashOffer in the updatedItem
        updatedItem.tradeOffer = convertToFixedPrecision(tradeOffer);
      } else {
        updatedItem.costOfGoods = convertToFixedPrecision(cashOffer); // Update cashOffer in the updatedItem
      }
      updatedItem.inStockPrice = getInStockPrice(updatedItem, markupPresets);

      if (updatedItem?.productsAvailableInInventory?.length) {
        const matchedProducts = isProductsExistInStock(
          updatedItem.productCondition,
          updatedItem.tags,
          updatedItem.cardRarity,
          updatedItem.productsAvailableInInventory,
          updatedItem
        );
        const matchedProduct = matchedProducts?.[0];
        updatedItem.variantId = matchedProduct?.variantId || EMPTY_STRING;
        updatedItem.shopifyInventoryItemId =
          matchedProduct?.shopifyInventoryItemId || EMPTY_STRING;
        if (matchedProduct?.shopifyId) {
          updatedItem.shopifyId = matchedProduct.shopifyId;
        }
      }
      return updatedItem;
    }

    return item;
  });

  setAddBatchInventory(handleBatchInventoryPercentage(updatedInventory));
};

//-------handle reset batch cog, cashoffer and tradeoffer prices
export const handleResetPrices = (
  markupPresets,
  isTradeBatch,
  addBatchInventory,
  setAddBatchInventory,
  tradeinMargin,
  handleBatchInventoryPercentage,
  currentStore,
  isResetToInStockCogs = false
) => {
  const updatedInventory = addBatchInventory.map((item) => {
    let marketPrice = item.marketPrice; // Initialize marketPrice outside the if block
    let newCondition = item.productCondition;
    const updatedItem = item;
    marketPrice = isStoreCustomProduct(item, "apiSource")
      ? item.inStockPrice
      : newCondition === PRODUCT_CONDITIONS_ENUMS.COMPLETE
      ? item?.completePrice ?? 0
      : newCondition === PRODUCT_CONDITIONS_ENUMS.LOOSE
      ? item?.loosePrice ?? 0
      : newCondition === PRODUCT_CONDITIONS_ENUMS.NEW
      ? item?.newPrice ?? 0
      : newCondition === PRODUCT_CONDITIONS_ENUMS.BOX_ONLY
      ? item?.boxOnlyPrice ?? 0
      : newCondition === PRODUCT_CONDITIONS_ENUMS.MANUAL_ONLY
      ? item?.manualPrice ?? 0
      : item?.marketPrice ?? 0;

    updatedItem.marketPrice = marketPrice;

    //-------calculate market price after reducing or adding prices based on tags
    const marketPriceAfterTagsApply = batchEditChangePriceBaseOnTags(
      updatedItem.tags,
      updatedItem,
      () => {},
      { value: updatedItem.productCondition },
      updatedItem.productType,
      tradeinMargin,
      markupPresets
    );

    updatedItem.marketPrice = marketPriceAfterTagsApply.marketPrice;

    //-------calculate market price after applying markup presets
    const marketPriceAfterPresetApply = getPresetStockPrice(
      updatedItem.productType,
      marketPriceAfterTagsApply.marketPrice,
      markupPresets,
      updatedItem
    );

    //-------if always use stock price for cogs is true then use inStockPrice as marketPrice
    //-------else use the minimum of inStockPrice and marketPriceAfterPresetApply
    const marketPriceToUse = currentStore?.[
      toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
    ]
      ? updatedItem.inStockPrice
      : decidePriceToUse(
          Number(updatedItem.inStockPrice),
          marketPriceAfterTagsApply.marketPrice,
          marketPriceAfterPresetApply
        );

    var tradeInMarginToApply = getMarginDropdownValue(
      marketPriceToUse,
      tradeinMargin,
      updatedItem.productType,
      {
        ...updatedItem,
        tags: updatedItem.tags,
        condition: updatedItem.productCondition,
        cardRarity: updatedItem?.cardRarity || EMPTY_STRING,
        subcategory: isStoreCustomProduct(item.apiSource)
          ? item.subcategory
          : getProductSubCategory(updatedItem.genre),
      }
    );
    if (!isStoreCustomProduct(updatedItem.apiSource)) {
      // Calculate offers based on marketPrice
      const { cashOffer, tradeOffer } = calculateOfferPrices(
        marketPriceToUse,
        tradeInMarginToApply.marginObject,
        tradeInMarginToApply?.marginObject.cashMarginPercentage,
        tradeInMarginToApply?.marginObject.tradeinMarginPercentage
      );

      if (isTradeBatch) {
        updatedItem.cashOffer = parseToDecimalNumber(cashOffer); // Update cashOffer in the updatedItem
        updatedItem.tradeOffer = parseToDecimalNumber(tradeOffer);
      } else {
        updatedItem.costOfGoods = isResetToInStockCogs
          ? getInStockPrice(item, markupPresets, true)
          : parseToDecimalNumber(cashOffer); // Update cashOffer in the updatedItem
      }
    }
    //------ Donot update inStockPrice here
    // updatedItem.inStockPrice = getInStockPrice(updatedItem, markupPresets);
    return updatedItem;
  });

  setAddBatchInventory(handleBatchInventoryPercentage(updatedInventory));
};

//-------handle trade value change for online and instore
export const handleTradeOfferValues = (
  InputValue,
  setFieldValue,
  initialRatio,
  isSeparateQuantity = false
) => {
  if (isSeparateQuantity) {
    const newTradeValue = parseFloat(InputValue);
    setFieldValue("onlineTradeOffer", newTradeValue);
    const newCashOffer = newTradeValue / initialRatio;
    setFieldValue("onlineCashOffer", parseToDecimalNumber(newCashOffer));
  } else {
    const newTradeValue = parseFloat(InputValue);
    setFieldValue("tradeOffer", newTradeValue);
    const newCashOffer = newTradeValue / initialRatio;
    setFieldValue("cashOffer", parseToDecimalNumber(newCashOffer));
  }
};

//-------handle cash value change for online and instore
export const handleCashOfferValues = (
  InputValue,
  setFieldValue,
  initialRatio,
  isSeparateQuantity = false
) => {
  if (isSeparateQuantity) {
    const newCashOffer = parseFloat(InputValue); // Assuming InputValue is the new cash offer value
    setFieldValue("onlineCashOffer", newCashOffer);

    const newTradeValue = newCashOffer * initialRatio;
    setFieldValue("onlineTradeOffer", parseToDecimalNumber(newTradeValue));
  } else {
    const newCashOffer = parseFloat(InputValue); // Assuming InputValue is the new cash offer value
    setFieldValue("cashOffer", newCashOffer);

    const newTradeValue = newCashOffer * initialRatio;
    setFieldValue("tradeOffer", parseToDecimalNumber(newTradeValue));
  }
};

export const handleTagList = (productTags, genre, condition, filterTag) => {
  const defaultTags =
    genre === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
      ? productTags?.systemsDefaultTags
      : productTags?.gamesDefaultTags;

  const conditionTags = {
    [PRODUCT_CONDITIONS_ENUMS.COMPLETE]: defaultTags?.complete,
    [PRODUCT_CONDITIONS_ENUMS.LOOSE]: defaultTags?.loose,
    [PRODUCT_CONDITIONS_ENUMS.BOX_ONLY]: defaultTags?.boxOnly,
    [PRODUCT_CONDITIONS_ENUMS.MANUAL_ONLY]: defaultTags?.manualOnly,
  };

  return (conditionTags[condition] || []).filter((tag) => tag !== filterTag);
};

const updateConditionsAndTags = (
  conditions,
  genre,
  productTags,
  setProductCondition,
  setConditionList,
  setProductTagsList,
  removeTag,
  isProductEdit = false,
  productToEdit
) => {
  setConditionList(conditions);
  const selectedCondition = isProductEdit
    ? conditions.find(
        (condition) => condition.value === productToEdit.price.type
      )
    : getProductSubCategory(genre) === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
    ? conditions[1]
    : conditions[0];
  setProductCondition(selectedCondition);
  setProductTagsList(
    handleTagList(productTags, genre, selectedCondition.value, removeTag)
  );
};

//-------handle condition and tag list
export const handleConditionsAndTags = (
  consoleName,
  genre,
  productTags,
  setConditionList,
  setProductCondition,
  setProductTagsList,
  condition,
  isProductEdit = false,
  productToEdit
) => {
  const isNintendo =
    inventoryConstants.NINTENDO_CATEGORIES.includes(consoleName);
  const isSkyLander =
    inventoryConstants.SKYLANDER_CATEGORIES.includes(consoleName);
  if (isNintendo) {
    updateConditionsAndTags(
      inventoryConstants.NINTENDO_CONDITIONS,
      genre,
      productTags,
      setProductCondition,
      setConditionList,
      setProductTagsList,
      inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL,
      isProductEdit,
      productToEdit
    );
  } else if (isSkyLander) {
    updateConditionsAndTags(
      inventoryConstants.SKYLANDERS_CONDITION,
      genre,
      productTags,
      setProductCondition,
      setConditionList,
      setProductTagsList,
      inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL,
      isProductEdit,
      productToEdit
    );
  } else {
    updateConditionsAndTags(
      condition,
      genre,
      productTags,
      setProductCondition,
      setConditionList,
      setProductTagsList,
      "",
      isProductEdit,
      productToEdit
    );
  }
};

//-------handle specific categories and its condotions
export const handleShowNintendoCondition = (category, condition) => {
  return inventoryConstants.NINTENDO_CATEGORIES.includes(category) &&
    condition === PRODUCT_CONDITIONS_ENUMS.COMPLETE
    ? PRODUCT_CONDITIONS_ENUMS.WITH_POSTER
    : condition;
};

//-------handle batch specific categories condition
export const handleBatchCondition = (category, conditions) => {
  return inventoryConstants.NINTENDO_CATEGORIES.includes(category)
    ? inventoryConstants.NINTENDO_CONDITIONS
    : inventoryConstants.SKYLANDER_CATEGORIES.includes(category)
    ? inventoryConstants.SKYLANDERS_CONDITION
    : conditions;
};

export const handleDefaultBatchCondition = (category, conditions, genre) => {
  return inventoryConstants.NINTENDO_CATEGORIES.includes(category)
    ? getProductSubCategory(genre) === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
      ? inventoryConstants.NINTENDO_CONDITIONS[1].value
      : inventoryConstants.NINTENDO_CONDITIONS[0].value
    : inventoryConstants.SKYLANDER_CATEGORIES.includes(category)
    ? getProductSubCategory(genre) === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
      ? inventoryConstants.SKYLANDERS_CONDITION[1].value
      : inventoryConstants.SKYLANDERS_CONDITION[0].value
    : getProductSubCategory(genre) === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
    ? conditions[1].value
    : conditions[0].value;
};

//-------Loading Indicator
export const LoadingIndicator = (props) => {
  const {
    color = "text-purple",
    className = EMPTY_STRING,
    isApplyMargin = true,
  } = props;
  return (
    <div
      className={`spinner-border spinner-border-sm ${color} ${className} 
      ${isApplyMargin && "ms-auto me-2"}`}
      role="status"
    >
      <span className="sr-only"></span>
    </div>
  );
};

export const LoadingIndicatorLarge = (props) => {
  const { color = "text-purple", className = EMPTY_STRING } = props;
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center ${className}`}
    >
      {/* Large spinner */}
      <div
        className={`spinner-border spinner-border-lg ${color}`}
        role="status"
      >
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export const addSearchKeyToArrayObject = (array, keys) => {
  return array.map((obj) => {
    const searchColumnData = keys.map((key) => obj[key]).join("");
    return { ...obj, searchColumnData };
  });
};

export const generateUuid = () => {
  return uuidv4();
};

export const calculateStockPriceByMarkup = (stockPrice, roundUpMethod) => {
  let newStockPrice = stockPrice;
  if (
    roundUpMethod === tradeInDiscountConstant.ROUND_VALUE_TO_95 &&
    newStockPrice !== 0
  ) {
    newStockPrice = Math.ceil(newStockPrice) - 0.05;
  } else if (
    roundUpMethod === tradeInDiscountConstant.ROUND_VALUE_TO_99 &&
    newStockPrice !== 0
  ) {
    newStockPrice = Math.ceil(newStockPrice) - 0.01;
  } else if (roundUpMethod === tradeInDiscountConstant.ROUND_VALUE_TO_00) {
    newStockPrice = Math.ceil(newStockPrice);
  }
  return parseToDecimalNumber(newStockPrice);
};

const findDefaultTradeInIfAny = (list) => {
  return list.find(
    (margin) =>
      margin.minPriceRange === tradeInDiscountConstant.DEFAULT_MIN_RANGE &&
      margin.maxPriceRange === tradeInDiscountConstant.DEFAULT_MAX_RANGE
  );
};

const findPriceRangeTradeInIfAny = (list, productMarketPrice) => {
  return list.find(
    (item) =>
      productMarketPrice >= item.minPriceRange &&
      productMarketPrice <= item.maxPriceRange
  );
};

const findFilterTradeInList = (
  list,
  key,
  value,
  groupType,
  isSubcategory = false,
  productCategory = EMPTY_STRING,
  isValidateEndDate = false // To explcude the expired discounts
) => {
  let updatedList = isSubcategory
    ? list?.filter((margin) =>
        margin[groupType].some(
          (group) =>
            group[key] === value &&
            group["parentCategoryName"] === productCategory
        )
      )
    : list?.filter((margin) =>
        margin[groupType].some((group) => group[key] === value)
      );

  //check if discount is expired
  if (isValidateEndDate) {
    updatedList = updatedList.filter((dis) => {
      if (
        calculateDuration(dis.startDate, dis.endDate) ===
        discountConstants.DISCOUNT_EXPIRED
      ) {
        return false;
      }
      return true;
    });
  }
  return updatedList;
};

// Helper function to find margin and return if found
const findMarginAndReturn = (
  productMarketPrice,
  marginList,
  filterProperty,
  filterValue,
  isSubCategory = false,
  defaultFilterValue = null
) => {
  const filteredMargins = findFilterTradeInList(
    marginList,
    filterProperty,
    filterValue,
    "marginGroup",
    isSubCategory,
    defaultFilterValue
  );
  if (filteredMargins?.length) {
    const foundMargin =
      findPriceRangeTradeInIfAny(filteredMargins, productMarketPrice) ||
      findDefaultTradeInIfAny(filteredMargins);
    if (foundMargin) {
      return {
        marginType: inventoryConstants.MARGIN_TYPE_STANDARD,
        marginObject: foundMargin,
      };
    }
  }
  return null;
};

const isProductMarginExist = (
  productMargins,
  productDataObject,
  productType,
  productMarketPrice
) => {
  const filteredMargins = productMargins?.filter(
    (margin) =>
      margin.productCondition === productDataObject.condition &&
      isArraySame(margin.tags, productDataObject.tags) &&
      margin.marginGroup.some(
        (group) =>
          String(group.product_name).toLowerCase() ===
            String(productDataObject.productName).toLowerCase() &&
          String(group.category_name).toLowerCase() ===
            String(productDataObject.consoleName).toLowerCase() &&
          String(group.subcategory).toLowerCase() ===
            String(productDataObject.subcategory).toLowerCase() &&
          group.cardRarity === productDataObject.cardRarity &&
          group.productType === productType
      )
  );

  if (filteredMargins?.length) {
    const foundMargin =
      findPriceRangeTradeInIfAny(filteredMargins, productMarketPrice) ||
      findDefaultTradeInIfAny(filteredMargins);
    if (foundMargin) {
      return {
        marginType: inventoryConstants.MARGIN_TYPE_STANDARD,
        marginObject: foundMargin,
      };
    }
  }
  return null;
};

export const getMarginDropdownValue = (
  marketPrice,
  marginTypes,
  productType,
  productDataObject,
  isGetSubCategoryFromGenre = true
) => {
  const productMarketPrice = Number(marketPrice);
  const { genre, consoleName } = productDataObject;
  let marginResult = false;

  // Check product margin if exist
  const productMargins = marginTypes.productMargins;

  marginResult = isProductMarginExist(
    productMargins,
    productDataObject,
    productType,
    marketPrice
  );
  if (marginResult) {
    return marginResult;
  }

  // Check subcategory margin with specific category
  marginResult = findMarginAndReturn(
    productMarketPrice,
    marginTypes.subcategoryMargins,
    "categoryName",
    isGetSubCategoryFromGenre ? getProductSubCategory(genre) : genre,
    true,
    consoleName
  );
  if (marginResult) {
    return marginResult;
  }

  // Check subcategory margin with all category
  marginResult = findMarginAndReturn(
    productMarketPrice,
    marginTypes.subcategoryMargins,
    "categoryName",
    isGetSubCategoryFromGenre ? getProductSubCategory(genre) : genre,
    true,
    PRODUCT_TYPES_ENUMS.ALL
  );
  if (marginResult) {
    return marginResult;
  }

  // Check category margin
  marginResult = findMarginAndReturn(
    productMarketPrice,
    marginTypes.categoryMargins,
    "categoryName",
    consoleName
  );
  if (marginResult) {
    return marginResult;
  }

  // Check product type margin
  marginResult = findMarginAndReturn(
    productMarketPrice,
    marginTypes.productTypeMargins,
    "productType",
    productType
  );
  if (marginResult) {
    return marginResult;
  }

  // Default to global margin
  return {
    marginType: inventoryConstants.MARGIN_TYPE_GLOBAL,
    marginObject: marginTypes?.globalMargin,
  };
};

// Helper function to find margin and return if found
const findShopifyMappingAndReturn = (
  productMarketPrice,
  marginList,
  filterProperty,
  filterValue,
  isSubCategory = false,
  defaultFilterValue = null
) => {
  const filteredMargins = findFilterTradeInList(
    marginList,
    filterProperty,
    filterValue,
    "group",
    isSubCategory,
    defaultFilterValue
  );

  if (filteredMargins?.length) {
    const foundMargin =
      findPriceRangeTradeInIfAny(filteredMargins, productMarketPrice) ||
      findDefaultTradeInIfAny(filteredMargins);
    if (foundMargin) {
      return {
        marginType: {
          ...inventoryConstants.MARGIN_TYPE_STANDARD,
          isDefault: false,
        },
        marginObject: foundMargin,
      };
    }
  }
  return null;
};

export const getDefaultShopifySettings = (
  marketPrice,
  shopifySettings,
  productType,
  productDataObject,
  isGetSubCategoryFromGenre = true
) => {
  const productMarketPrice = Number(marketPrice);
  const { genre, consoleName } = productDataObject;
  let marginResult = false;

  // Check subcategory margin with all category
  marginResult = findShopifyMappingAndReturn(
    productMarketPrice,
    shopifySettings.subcategory,
    "categoryName",
    isGetSubCategoryFromGenre ? getProductSubCategory(genre) : genre,
    true,
    consoleName
  );
  if (marginResult) {
    return marginResult;
  }

  // Check category margin
  marginResult = findShopifyMappingAndReturn(
    productMarketPrice,
    shopifySettings.category,
    "categoryName",
    consoleName
  );
  if (marginResult) {
    return marginResult;
  }

  // Check product type margin
  marginResult = findShopifyMappingAndReturn(
    productMarketPrice,
    shopifySettings.productType,
    "productType",
    productType
  );
  if (marginResult) {
    return marginResult;
  }

  // Default to global margin
  return {
    marginType: { ...inventoryConstants.MARGIN_TYPE_GLOBAL, isDefault: false },
    marginObject: shopifySettings?.global,
  };
};

// If product is not existing in db so we will not use the mapping saved in shopify presets directly. first we will find the mapping of product with different condition has any mapping if yes then will use that one in combination with saved shopify preset setting
export const handleGetDbProductMergedShopifySettings = async (
  currentStore,
  inventoryProducts,
  modalProductObject,
  fallBackShopifySettingId,
  shopifySettingsBasedOnPresetSetByUser
) => {
  let value = fallBackShopifySettingId;
  if (
    isShopifyConnected(currentStore) &&
    inventoryProducts.length &&
    shopifySettingsBasedOnPresetSetByUser?.marginObject?.shopifyMapping
  ) {
    let dbOtherVariantWithMapping = inventoryProducts.find(
      (product) =>
        product.shopifySettingId &&
        product.isLinkToShopify &&
        product.product_name === modalProductObject.productName
    );
    let dbOtherVariantShopifySetting = null;
    if (dbOtherVariantWithMapping) {
      dbOtherVariantShopifySetting =
        await shopifyService.getShopifyMappingsById(
          currentStore.id,
          dbOtherVariantWithMapping.shopifySettingId
        );
    }
    if (
      dbOtherVariantWithMapping &&
      dbOtherVariantShopifySetting?.shopifyMapping?.title
    ) {
      let combinedMapping = {
        ...shopifySettingsBasedOnPresetSetByUser,
        marginObject: {
          ...shopifySettingsBasedOnPresetSetByUser?.marginObject,
          id: undefined,
          isInitialShopifySetting: false,
          shopifyMapping: getMappedShopifyFields({
            ...shopifySettingsBasedOnPresetSetByUser?.marginObject
              ?.shopifyMapping,
            title: dbOtherVariantShopifySetting.shopifyMapping.title,
            body_html: dbOtherVariantShopifySetting.shopifyMapping.body_html,
            shopifyTags:
              dbOtherVariantShopifySetting.shopifyMapping.shopifyTags,
            vendor: dbOtherVariantShopifySetting.shopifyMapping.vendor,
            product_type:
              dbOtherVariantShopifySetting.shopifyMapping.product_type,
            tags: dbOtherVariantShopifySetting.shopifyMapping.tags,
            template_suffix:
              dbOtherVariantShopifySetting?.shopifyMapping?.template_suffix ??
              EMPTY_STRING,
          }),
        },
      };
      let newCombinedShopifyMapping =
        await shopifyService.createProductMappingObject(
          currentStore.id,
          combinedMapping.marginObject
        );
      value = newCombinedShopifyMapping.id;
    }
  }
  return value;
};

const findMarkupAndReturn = (
  markupPresets,
  stockPrice,
  productMarketPrice,
  markupList,
  filterProperty,
  filterValue,
  isSubCategory = false,
  defaultFilterValue = null
) => {
  const filteredMarkups = findFilterTradeInList(
    markupList,
    filterProperty,
    filterValue,
    "markupGroup",
    isSubCategory,
    defaultFilterValue
  );
  if (filteredMarkups?.length) {
    const foundMarkup =
      findPriceRangeTradeInIfAny(filteredMarkups, productMarketPrice) ||
      findDefaultTradeInIfAny(filteredMarkups);
    if (foundMarkup) {
      stockPrice *= 1 + foundMarkup.markupPercentage / 100;
      return calculateStockPriceByMarkup(
        stockPrice,
        markupPresets.globalMarkup.roundValuesTo
      );
    }
  }
  return null;
};

//-------get stock price based on market price and stock price
export const getPresetStockPrice = (
  productType,
  marketPrice,
  markupPresets,
  productDataObject,
  isInventoryProduct = false,
  subcategory = EMPTY_STRING,
  categoryName = EMPTY_STRING
) => {
  let productMarketPrice = Number(marketPrice);
  let stockPrice = productMarketPrice;
  const { genre, consoleName } = productDataObject;

  // Check subcategory markup with specific category
  let markupResult = findMarkupAndReturn(
    markupPresets,
    stockPrice,
    productMarketPrice,
    markupPresets.subcategoryMarkups,
    "categoryName",
    isInventoryProduct ? subcategory : getProductSubCategory(genre),
    true,
    isInventoryProduct ? categoryName : consoleName
  );
  if (markupResult) {
    return markupResult;
  }

  // Check subcategory markup with all category
  markupResult = findMarkupAndReturn(
    markupPresets,
    stockPrice,
    productMarketPrice,
    markupPresets.subcategoryMarkups,
    "categoryName",
    isInventoryProduct ? getProductSubCategory(genre) : subcategory,
    true,
    PRODUCT_TYPES_ENUMS.ALL
  );
  if (markupResult) {
    return markupResult;
  }

  // Check category markup
  markupResult = findMarkupAndReturn(
    markupPresets,
    stockPrice,
    productMarketPrice,
    markupPresets.categoryMarkups,
    "categoryName",
    isInventoryProduct ? categoryName : consoleName
  );
  if (markupResult) {
    return markupResult;
  }

  // Check product type markup
  markupResult = findMarkupAndReturn(
    markupPresets,
    stockPrice,
    productMarketPrice,
    markupPresets.productTypeMarkups,
    "productType",
    productType
  );
  if (markupResult) {
    return markupResult;
  }

  stockPrice *= 1 + markupPresets.globalMarkup.markupPercentage / 100;

  return calculateStockPriceByMarkup(
    stockPrice,
    markupPresets.globalMarkup.roundValuesTo
  );
};

// Decide which price to use based on comparison with market price and stock price
export const decidePriceToUse = (newPrice, marketPrice, newMarketPrice) => {
  return newPrice >= Number(marketPrice) ? newMarketPrice : newPrice;
};

// ------find discount and return it
const findDisocuntAndReturn = (
  productMarketPrice,
  markupList,
  filterProperty,
  filterValue,
  isSubCategory = false,
  defaultFilterValue = null
) => {
  const filteredMarkups = findFilterTradeInList(
    markupList,
    filterProperty,
    filterValue,
    "discountGroup",
    isSubCategory,
    defaultFilterValue,
    true
  );
  if (filteredMarkups?.length) {
    const foundDiscount =
      findPriceRangeTradeInIfAny(filteredMarkups, productMarketPrice) ||
      findDefaultTradeInIfAny(filteredMarkups);
    if (
      foundDiscount &&
      checkDiscountValidity(foundDiscount.startDate, foundDiscount.endDate)
    ) {
      return foundDiscount;
    }
  }
  return null;
};

//-------get stock price based on market price and stock price
export const getProductDiscount = (product, discounts) => {
  let productStockPrice = Number(product.price);
  const { category, productType, genre, subcategory } = product;
  // Check subcategory discount with specific category
  let discountResult = findDisocuntAndReturn(
    productStockPrice,
    discounts.subCategoryDiscounts,
    "categoryName",
    subcategory,
    true,
    category
  );
  if (discountResult) {
    return discountResult;
  }

  // Check subcategory discount with all category
  discountResult = findDisocuntAndReturn(
    productStockPrice,
    discounts.subCategoryDiscounts,
    "categoryName",
    subcategory,
    true,
    PRODUCT_TYPES_ENUMS.ALL
  );
  if (discountResult) {
    return discountResult;
  }

  // Check category discount
  discountResult = findDisocuntAndReturn(
    productStockPrice,
    discounts.categoryDiscounts,
    "categoryName",
    category
  );
  if (discountResult) {
    return discountResult;
  }

  // Check product type discount
  discountResult = findDisocuntAndReturn(
    productStockPrice,
    discounts.productTypeDiscounts,
    "productType",
    productType
  );
  if (discountResult) {
    return discountResult;
  }
};

export const handleMarginChange = (
  marketPrice,
  productType,
  setFieldValue,
  selectedOption,
  marginTypesvalue,
  productDataObject,
  setMarginTypeObject
) => {
  let marginTypeObject = {};
  let margin = {};

  let marginObject;

  if (selectedOption === inventoryConstants.MARGIN_TYPE_GLOBAL) {
    marginObject = marginTypesvalue.globalMargin;
  } else {
    marginObject = getMarginDropdownValue(
      marketPrice,
      marginTypesvalue,
      productType,
      {
        ...productDataObject,
        tags: productDataObject.tags,
        condition: productDataObject.productCondition,
        cardRarity: productDataObject?.cardRarity || EMPTY_STRING,
        subcategory: getProductSubCategory(productDataObject.genre),
      }
    ).marginObject;
  }

  if (marginObject) {
    const tradeinMarginPercentage = marginObject.tradeinMarginPercentage / 100;
    const cashMarginPercentage = marginObject.cashMarginPercentage / 100;
    marginTypeObject = {
      marginType: inventoryConstants.MARGIN_TYPE_STANDARD,
      marginObject: marginObject,
    };
    margin = {
      cashTradeMarginPercentage: cashMarginPercentage / tradeinMarginPercentage,
    };
    const { cashOffer, tradeOffer } = calculateOfferPrices(
      marketPrice,
      marginObject,
      marginObject.cashMarginPercentage,
      marginObject.tradeinMarginPercentage
    );

    setFieldValue("tradeOffer", convertToFixedPrecision(tradeOffer));
    setFieldValue("cashOffer", convertToFixedPrecision(cashOffer));
  }

  const updatedMarginObject = {
    marginType:
      selectedOption === inventoryConstants.MARGIN_TYPE_GLOBAL
        ? inventoryConstants.MARGIN_TYPE_GLOBAL
        : inventoryConstants.MARGIN_TYPE_STANDARD,
    marginObject: marginObject,
  };

  setMarginTypeObject(updatedMarginObject);
};

/**
 * Runs when the condition changes.
 *
 * It updates condition-based data such as prices and available tags.
 * If preserve state is passed in, this is treated as a partial update,
 * so user-entered fields are kept while calculated fields are refreshed.
 */
export const handleConditionChange = (
  selectedOption,
  setProductCondition,
  priceChartingProductInfo,
  productTags,
  setProductTagsList,
  setProductDataObject,
  productDataObject,
  setSelectedTags,
  setPriceChartingProductInfo = () => {},
  preserveStateRef = null,
  preserveModeEnum = null
) => {
  // Keep user input while refreshing calculated values.
  if (preserveStateRef && preserveModeEnum) {
    preserveStateRef.current.mode = preserveModeEnum.PARTIAL;
    preserveStateRef.current.hasInteracted = true;
  }
  if (!selectedOption?.value) return;

  setProductCondition(selectedOption);
  const { value } = selectedOption;
  let conditionObject = {};

  // Calculate marketPrice, suggestedSellPrice etc based on selected condition
  if (
    priceChartingProductInfo?.productMetaData?.productType ===
    PRODUCT_TYPES_ENUMS.TRADING_CARD
  ) {
    let updatedPriceChartingProductInfo = handleOnchangeTradingCardCondition(
      selectedOption,
      priceChartingProductInfo
    );
    // conditionObject = {
    //   [selectedOption.label]: {
    //     marketPrice:
    //       updatedPriceChartingProductInfo.productMetaData.marketPrice,
    //     suggestedSellPrice:
    //       updatedPriceChartingProductInfo.productMetaData.suggestedSellPrice,
    //   },
    // };
    setPriceChartingProductInfo(updatedPriceChartingProductInfo);
    conditionObject = updatedPriceChartingProductInfo.productMetaData;
  }
  // Pricecharting products (Video Game)
  else {
    const conditionData = {
      [PRODUCT_CONDITIONS_ENUMS.COMPLETE]: {
        marketPrice:
          priceChartingProductInfo?.productObject[
            inventoryConstants.COMPLETE_IN_BOX_PRICE
          ] || 0,
        suggestedSellPrice:
          priceChartingProductInfo?.productObject[
            inventoryConstants.RETAIL_COMPLETE_IN_BOX_PRICE
          ] || 0,
        networkAverageBuySellPrices: {
          ...getNetworkAvgBuySellPricesAccordingCondition(
            PRODUCT_CONDITIONS_ENUMS.COMPLETE,
            priceChartingProductInfo
          ),
        },
      },
      [PRODUCT_CONDITIONS_ENUMS.NEW]: {
        marketPrice:
          priceChartingProductInfo?.productObject[inventoryConstants.NEW_PRICE],
        suggestedSellPrice:
          priceChartingProductInfo?.productObject[
            inventoryConstants.RETAIL_NEW_PRICE
          ] || 0,
        networkAverageBuySellPrices: {
          ...getNetworkAvgBuySellPricesAccordingCondition(
            PRODUCT_CONDITIONS_ENUMS.NEW,
            priceChartingProductInfo
          ),
        },
      },
      [PRODUCT_CONDITIONS_ENUMS.LOOSE]: {
        marketPrice:
          priceChartingProductInfo?.productObject[
            inventoryConstants.LOOSE_PRICE
          ] || 0,
        suggestedSellPrice:
          priceChartingProductInfo?.productObject[
            inventoryConstants.RETAIL_LOOSE_PRICE
          ] || 0,
        networkAverageBuySellPrices: {
          ...getNetworkAvgBuySellPricesAccordingCondition(
            PRODUCT_CONDITIONS_ENUMS.LOOSE,
            priceChartingProductInfo
          ),
        },
      },
      [PRODUCT_CONDITIONS_ENUMS.BOX_ONLY]: {
        marketPrice:
          priceChartingProductInfo?.productObject[
            inventoryConstants.BOX_ONLY_PRICE
          ] || 0,
        suggestedSellPrice: 0,
        networkAverageBuySellPrices: {
          ...getNetworkAvgBuySellPricesAccordingCondition(
            PRODUCT_CONDITIONS_ENUMS.BOX_ONLY,
            priceChartingProductInfo
          ),
        },
      },
      [PRODUCT_CONDITIONS_ENUMS.MANUAL_ONLY]: {
        marketPrice:
          priceChartingProductInfo?.productObject[
            inventoryConstants.MANUAL_ONLY_PRICE
          ] || 0,
        suggestedSellPrice: 0,
        networkAverageBuySellPrices: {
          ...getNetworkAvgBuySellPricesAccordingCondition(
            PRODUCT_CONDITIONS_ENUMS.MANUAL_ONLY,
            priceChartingProductInfo
          ),
        },
      },
    };
    conditionObject = conditionData[value] || {};
  }

  setProductDataObject((prevState) => ({
    ...prevState,
    ...conditionObject,
  }));

  setProductTagsList(
    handleTagList(
      productTags,
      priceChartingProductInfo?.productObject.genre,
      value,
      inventoryConstants.NINTENDO_CATEGORIES.includes(
        priceChartingProductInfo?.productObject[
          inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
        ]
      ) ||
        inventoryConstants.SKYLANDER_CATEGORIES.includes(
          priceChartingProductInfo?.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
          ]
        )
        ? value === PRODUCT_CONDITIONS_ENUMS.COMPLETE
          ? inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL
          : inventoryConstants.PRODUCT_TAGS.WITH_MANUAL
        : ""
    )
  );

  setSelectedTags([]);
};

export const getMarketPriceBaseOnCondition = (productDataObject) => {
  return {
    [PRODUCT_CONDITIONS_ENUMS.COMPLETE]: {
      marketPrice: productDataObject?.completePrice || 0,
      suggestedSellPrice: productDataObject?.suggestedSellPriceComplete || 0,
    },
    [PRODUCT_CONDITIONS_ENUMS.NEW]: {
      marketPrice: productDataObject?.newPrice || 0,
      suggestedSellPrice: productDataObject?.suggestedSellPriceNew || 0,
    },
    [PRODUCT_CONDITIONS_ENUMS.LOOSE]: {
      marketPrice: productDataObject?.loosePrice || 0,
      suggestedSellPrice: productDataObject?.suggestedSellPriceLoose || 0,
    },
    [PRODUCT_CONDITIONS_ENUMS.BOX_ONLY]: {
      marketPrice: productDataObject?.boxOnlyPrice || 0,
      suggestedSellPrice: 0,
    },
    [PRODUCT_CONDITIONS_ENUMS.MANUAL_ONLY]: {
      marketPrice: productDataObject?.manualPrice || 0,
      suggestedSellPrice: 0,
    },
  };
};

export const handleEditBatchConditionChange = (
  markupPresets,
  selectedOption,
  setProductCondition,
  productTags,
  setProductTagsList,
  setProductDataObject,
  productDataObject,
  setSelectedTags,
  tradeinMargin,
  setAddSelectedTags,
  isTradeBatch = false,
  setPriceChartingProductInfo,
  preserveStateRef
) => {
  preserveStateRef.current.hasInteracted = true;
  preserveStateRef.current.mode = preserveMode.PARTIAL;
  //-------selected product condition not fonud
  if (!selectedOption?.value) return;

  //-------set product condition
  setProductCondition(selectedOption);

  const { value } = selectedOption;

  const updatedItem = productDataObject;
  updatedItem.productCondition = selectedOption?.value;
  updatedItem.condition = updatedItem.productCondition;
  const conditionData =
    productDataObject.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD
      ? getTradingCardMarketPriceForSelectedProperties(
          productDataObject,
          productDataObject.language,
          selectedOption,
          productDataObject.cardRarity,
          true
        )
      : getMarketPriceBaseOnCondition(productDataObject);

  updatedItem.marketPrice = conditionData[value]?.marketPrice || 0;
  updatedItem.suggestedSellPrice =
    conditionData[value]?.suggestedSellPrice || 0;
  updatedItem.networkAverageBuySellPrices =
    getNetworkAvgBuySellPricesAccordingCondition(value, {
      productObject: productDataObject,
    });

  var tradeInMarginToApply = getMarginDropdownValue(
    updatedItem.marketPrice,
    tradeinMargin,
    updatedItem.productType,
    {
      ...updatedItem,
      tags: updatedItem.tags,
      condition: updatedItem.productCondition,
      cardRarity: updatedItem?.cardRarity || EMPTY_STRING,
      subcategory: getProductSubCategory(updatedItem.genre),
    }
  );
  const { cashOffer, tradeOffer } = calculateOfferPrices(
    updatedItem.marketPrice,
    tradeInMarginToApply.marginObject,
    tradeInMarginToApply.marginObject.cashMarginPercentage,
    tradeInMarginToApply.marginObject.tradeinMarginPercentage
  );

  if (isTradeBatch) {
    updatedItem.cashOffer = convertToFixedPrecision(cashOffer); // Update cashOffer in the updatedItem
    updatedItem.tradeOffer = convertToFixedPrecision(tradeOffer);
  } else {
    updatedItem.costOfGoods = convertToFixedPrecision(cashOffer); // Update cashOffer in the updatedItem
  }

  const existingProduct = findExistingStockProduct({
    ...updatedItem,
    productCondition: selectedOption?.value,
  });

  updatedItem.inStockPrice = existingProduct?.length
    ? existingProduct[0]?.price?.unit_sell_price
    : getPresetStockPrice(
        updatedItem.productType,
        updatedItem.marketPrice,
        markupPresets,
        updatedItem
      );
  updatedItem.tags = [];
  setProductDataObject(updatedItem);
  setPriceChartingProductInfo({
    productMetaData: updatedItem,
    productObject: updatedItem.productObject,
  });

  setProductTagsList(
    handleTagList(
      productTags,
      productDataObject?.genre,
      value,
      inventoryConstants.NINTENDO_CATEGORIES.includes(
        productDataObject?.consoleName
      ) ||
        inventoryConstants.SKYLANDER_CATEGORIES.includes(
          productDataObject?.consoleName
        )
        ? value === PRODUCT_CONDITIONS_ENUMS.COMPLETE
          ? inventoryConstants.PRODUCT_TAGS.MISSING_MANUAL
          : inventoryConstants.PRODUCT_TAGS.WITH_MANUAL
        : ""
    )
  );
  setSelectedTags([]);
  setAddSelectedTags([]);
};

export const handleRaritiesChangeInSingleAddEdit = (
  selectedOption,
  setSelectedRarity,
  setProductDataObject,
  productDataObject,
  tradeinMargin,
  markupPresets
) => {
  let updatedProductDataObject = productDataObject;
  if (selectedOption) {
    setSelectedRarity(selectedOption);
    let marketPrice = parseToNumber(
      selectedOption?.value?.value ?? productDataObject.marketPrice
    );
    var tradeInMarginToApply = getMarginDropdownValue(
      marketPrice,
      tradeinMargin,
      productDataObject.productType,
      {
        ...productDataObject,
        tags: productDataObject.selectedTags,
        condition: productDataObject.productCondition,
        cardRarity: selectedOption || EMPTY_STRING,
        subcategory: getProductSubCategory(productDataObject.genre),
      }
    );
    const { cashOffer, tradeOffer } = calculateOfferPrices(
      marketPrice,
      tradeInMarginToApply.marginObject,
      tradeInMarginToApply.marginObject.cashMarginPercentage,
      tradeInMarginToApply.marginObject.tradeinMarginPercentage
    );

    const existingProduct = findExistingStockProduct({
      ...productDataObject,
      cardRarity: selectedOption,
    });

    const inStockPrice = existingProduct?.length
      ? existingProduct[0]?.price?.unit_sell_price
      : getPresetStockPrice(
          productDataObject.productType,
          marketPrice,
          markupPresets,
          productDataObject
        );

    updatedProductDataObject = {
      ...productDataObject,
      marketPrice: marketPrice,
      cashOffer: convertToFixedPrecision(cashOffer),
      tradeOffer: convertToFixedPrecision(tradeOffer),
      inStockPrice: inStockPrice,
      costOfGoods: convertToFixedPrecision(cashOffer),
      cardRarity: selectedOption,
    };
    setProductDataObject(updatedProductDataObject);
  }

  return updatedProductDataObject;
};

export const getProductDetailCardTags = (tags, sku) => {
  if (tags && tags?.length === 0) {
    return "";
  } else {
    return (
      <TableCustomHeader
        id={`sku-number-in-array-${getShortestSku(sku)}`}
        label={<span>{`tag(${tags?.length})`}</span>}
        tooltopText={
          <div className="d-flex flex-column ">
            {tags?.map((s) => (
              <p className=" sku-wrapper text-nowrap text-start fw-normal m-0">
                {s}
              </p>
            ))}
          </div>
        }
        className="sku-tooltip ms-1"
      />
    );
  }
};

/**
 *
 * Add Trade, and Batch Edit forms.
 *
 * Why this exists:
 * - These forms reinitialize when condition/tags/shopify state changes.
 * - Without preserve state, user-typed values can get wiped.
 *
 * Modes expected by callers:
 * - NONE: reset form for a fresh product context.
 * - PARTIAL: keep user-entered fields, refresh calculated values.
 * - ALL: keep everything during submit/shopify operations.
 *
 * hasInteracted:
 * - true once user edits fields.
 * - false for a fresh state where no user input should be preserved.
 */
export const updatePreserveState = (
  preserveStateRef,
  mode,
  hasInteracted = true
) => {
  if (!preserveStateRef?.current) return;
  preserveStateRef.current.hasInteracted = hasInteracted;
  preserveStateRef.current.mode = mode;
};

export const getProductSubCategory = (
  productGenre,
  priceChartingProductInfo
) => {
  const productMetaData = priceChartingProductInfo?.productMetaData
    ? priceChartingProductInfo?.productMetaData
    : priceChartingProductInfo;
  if (
    productMetaData &&
    productMetaData.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD
  ) {
    return productMetaData.subcategory || EMPTY_STRING;
  } else {
    for (let item of GENRE_SUB_CATEGORY.PRICECHARTING_GENRE) {
      if (item.genre.includes(productGenre)) {
        return item.subCategory || EMPTY_STRING;
      }
    }
  }
  return EMPTY_STRING;
};

export const handleShowCategoryName = (isSubcategory, category) => {
  let name = EMPTY_STRING;
  if (isSubcategory) {
    name = category.parentCategoryName + " - " + category.name;
  } else {
    name = category.productTypeName + " - " + category.name;
  }
  return name;
};

// set the selected options in edit case of tradeins margin, preset prices and discount
export const handleMapSelectedOptionsInEdit = (
  groupArray,
  groupType,
  isDiscount = false
) => {
  //for discounts we have some seperate mappings
  if (isDiscount) {
    return groupArray.map((option) => {
      return groupType === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
        ? {
            id: option.categoryId,
            subcategoryName: option.categoryName,
            parentCategoryId: option.parentCategoryId,
            categoryName: option.parentCategoryName,
            productTypeName:
              option.productTypeName || option?.productType || EMPTY_STRING,
          }
        : groupType === SET_BY_MARGIN_ENUMS.PRODUCT.value
        ? {
            product_id: option.product_id,
            product_name: option.product_name,
            productType: option.productType,
            category_name: option.category_name,
            cardRarity: option.cardRarity,
            subcategory: option.subcategory,
          }
        : groupType === SET_BY_MARGIN_ENUMS.TYPE.value
        ? {
            id: undefined,
            productTypeName: option?.productType,
          }
        : {
            id: option.categoryId,
            categoryName: option.categoryName,
            productTypeName:
              option.productTypeName || option?.productType || EMPTY_STRING,
          };
    });
  } else {
    return groupArray.map((option) => {
      return groupType === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
        ? {
            id: option.categoryId,
            name: option.categoryName,
            parentCategoryId: option.parentCategoryId,
            parentCategoryName: option.parentCategoryName,
          }
        : groupType === SET_BY_MARGIN_ENUMS.PRODUCT.value
        ? {
            product_id: option.product_id,
            product_name: option.product_name,
            productType: option.productType,
            category_name: option.category_name,
            cardRarity: option.cardRarity,
            subcategory: option.subcategory,
          }
        : {
            id:
              groupType === SET_BY_MARGIN_ENUMS.TYPE.value
                ? undefined
                : option.categoryId,
            name:
              groupType === SET_BY_MARGIN_ENUMS.TYPE.value
                ? option?.productType
                : option.categoryName,
          };
    });
  }
};

// filters add/edit modal search field options for tradeins margin, preset prices and discount
export const filterApplyToSearchOptions = (
  setBy,
  productTypes,
  categories,
  subcategories,
  filterProductType,
  filterProductCategory,
  selectedCategories,
  isDiscount = false
) => {
  //for discounts we get array of categories, as it is multiselect for discounts
  if (isDiscount) {
    let filterOptions = [];
    if (setBy === SET_BY_MARGIN_ENUMS.TYPE.value) {
      filterOptions = productTypes.map((type) => ({
        id: type.id,
        productTypeName: type.productType,
      }));
    } else if (setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value) {
      filterOptions = categories.map((category) => ({
        id: category.id,
        productTypeId: category.productTypeId,
        categoryName: category.name,
        productTypeName: category.productTypeName,
      }));
      //filter the options for the selected type
      if (filterProductType.label !== PRODUCT_TYPES_ENUMS.ALL) {
        filterOptions = filterOptions.filter(
          (item) => item.productTypeId === filterProductType.value
        );
      }
    } else if (setBy === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value) {
      filterOptions = subcategories?.map((subcategory) => ({
        id: subcategory.id,
        productTypeId: subcategory.parentProductTypeId,
        parentCategoryId: subcategory.parentCategoryId,
        subcategoryName: subcategory.name,
        productTypeName: subcategory.parentProductTypeName,
        categoryName: subcategory.parentCategoryName,
      }));
      //filter the options for the selected type
      if (filterProductType.label !== PRODUCT_TYPES_ENUMS.ALL) {
        filterOptions = filterOptions.filter(
          (item) => item.productTypeId === filterProductType.value
        );
      }
    }

    //get the selectedCategories which have category in filterProductCategory then call this filter
    let filteredCategories;
    let applyingFilter = false;
    if (filterProductCategory) {
      if (Array.isArray(filterProductCategory) && selectedCategories) {
        const allowedCategoryIds = filterProductCategory.map(
          (cat) => cat.value
        );
        //If subcategory for one of categories is already present or subcategory with All for category is present
        filteredCategories = selectedCategories.filter(
          (item) =>
            allowedCategoryIds.includes(item.parentCategoryId) ||
            item.parentCategoryId === PRODUCT_TYPES_ENUMS.ALL
        );
        applyingFilter = true;
      }
    }
    //any of subcategories which are selected for one or more of the categories currently selected they will be filtered from list
    const selectedValueNameList = applyingFilter
      ? filteredCategories?.map((item) => item.id)
      : selectedCategories?.map((item) => item.id);

    filterOptions = filterOptions.filter(
      (item) => !selectedValueNameList?.includes(item.id)
    );

    return filterOptions;
  } else {
    let filterOptions = [];
    if (setBy === SET_BY_MARGIN_ENUMS.TYPE.value) {
      filterOptions = productTypes.map((type) => ({
        id: type.id,
        name: type.productType,
      }));
    } else if (setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value) {
      filterOptions = categories.map((category) => ({
        id: category.id,
        productTypeId: category.productTypeId,
        name: category.name,
      }));

      if (filterProductType.label !== PRODUCT_TYPES_ENUMS.ALL) {
        filterOptions = filterOptions.filter(
          (item) => item.productTypeId === filterProductType.value
        );
      }
    } else if (setBy === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value) {
      filterOptions = subcategories?.map((subcategory) => ({
        id: subcategory.id,
        productTypeId: subcategory.parentProductTypeId,
        parentCategoryId: subcategory.parentCategoryId,
        name: subcategory.name,
      }));
      if (filterProductType.label !== PRODUCT_TYPES_ENUMS.ALL) {
        filterOptions = filterOptions.filter(
          (item) => item.productTypeId === filterProductType.value
        );
      }
    }

    const selectedValueNameList = selectedCategories?.map((item) => item.name);

    //filter the subcategories that have already been selected
    filterOptions = filterOptions.filter(
      (item) => !selectedValueNameList?.includes(item.name)
    );

    return filterOptions;
  }
};

export const handleRemoveSelectedCategory = (
  categoryToRemove,
  selectedCategories,
  searchCategories
) => {
  let updatedSelectedCategories = selectedCategories.filter(
    (category) => category.name !== categoryToRemove
  );
  let updatedSearchCategories = [];

  const fullCategoryObject = selectedCategories.find(
    (category) => category.name === categoryToRemove
  );

  if (fullCategoryObject) {
    updatedSearchCategories = [...searchCategories, fullCategoryObject].sort(
      (a, b) => a.name.localeCompare(b.name)
    );
  } else {
    updatedSearchCategories = searchCategories;
  }

  return {
    updatedSelectedCategories,
    updatedSearchCategories,
  };
};

export const getTypeOrCategoryObject = (list, id) => {
  return list.find((item) => item.id === id);
};

export const getTypeOrCategoryIdByName = (
  list,
  name,
  productTypeName = false,
  categoryName = false,
  subcategoryName = false
) => {
  // in case of productType (check productType), in case of category (check productType and category) and in case of subcategory check (productType, subcategory)
  const obj = list.find((item) => {
    // productType case
    if (!productTypeName && !categoryName && !subcategoryName) {
      return item.productType === name;
    }
    // category case
    else if (productTypeName && !categoryName && !subcategoryName) {
      return item.name === name && item.productTypeName === productTypeName;
    }
    // subcategory case (It's same as category because both are linked to productType now: in db system subcategories has c.parentCategoryName="SYSTEM_SUBCATEGORY", old custom subcategories (subcategory before the relation update) has c.parentCategoryName="actual category name" and new custom subcategories has c.parentCategoryName="LOCAL_CATEGORY")
    else if (productTypeName && categoryName && !subcategoryName) {
      return (
        item.name === name && item.parentProductTypeName === productTypeName
      );
    } else {
      return false;
    }
  });
  return obj?.id ?? EMPTY_STRING;
};

export const getCustomTypesOptionList = (list) => {
  return (
    list?.map((item) => ({
      value: item.id,
      label: item.productType,
    })) || []
  );
};

export const getCustomCategoriesOptionList = (list, id, isAll) => {
  const filterList =
    isAll === PRODUCT_TYPES_ENUMS.ALL || !id
      ? list
      : list.filter((item) => item.productTypeId === id);
  return (
    filterList?.map((item) => ({
      value: item.id,
      label: item.name,
    })) || []
  );
};

export const getCustomProductSaleTypeOptionList = () => {
  return [
    { value: false, label: "In-Store" },
    { value: true, label: "Online" },
  ];
};
export const getCustomSubCategoriesOptionList = (
  subCategoriesArray,
  selectedCategoryId,
  selectedProductType = null,
  selectedProductTypeId = null,
  isExcludeCustom = false,
  categoriesArray = [],
  productTypesArray = []
) => {
  let subCategoriesList = [...subCategoriesArray];
  if (isExcludeCustom) {
    subCategoriesList = subCategoriesList.filter(
      (subCategory) => !subCategory.isCustom
    );
  }

  // find Video Game productTypeId and selected category productTypeId
  let selectedCategoryTypeId = null;
  let selectedCategory = null;
  let videoGameTypeId = null;
  let systemSubCategory = null;
  if (categoriesArray.length) {
    systemSubCategory = subCategoriesList.find(
      (subCategory) => !subCategory.isCustom
    );
    if (systemSubCategory) {
      videoGameTypeId = systemSubCategory.parentProductTypeId;
    }
    // find selected category type id
    selectedCategory = categoriesArray.find(
      (category) => selectedCategoryId === category.id
    );
    if (selectedCategory) {
      selectedCategoryTypeId = selectedCategory.productTypeId;
    }
  }

  // find productTypeName by productTypeId if it's null
  if (
    productTypesArray.length &&
    !selectedProductType &&
    selectedProductTypeId
  ) {
    selectedProductType = productTypesArray.find(
      (productType) => productType.id === selectedProductTypeId
    )?.productType;
  }

  // Filter subcategories according to selected productType and category
  const filterList =
    !selectedProductType ||
    (selectedProductType === PRODUCT_TYPES_ENUMS.ALL && !selectedCategoryId)
      ? subCategoriesList
      : selectedProductType === PRODUCT_TYPES_ENUMS.ALL && selectedCategoryId
      ? subCategoriesList.filter((item) => {
          return item.parentProductTypeId === selectedCategoryTypeId;
        })
      : selectedProductType && !selectedCategoryId
      ? subCategoriesList.filter(
          (item) => item.parentProductTypeId === selectedProductTypeId
        )
      : subCategoriesList.filter(
          (item) => item.parentProductTypeId === selectedCategoryTypeId
        );

  return (
    filterList?.map((item) => ({
      value: item.id,
      label: item.name,
    })) || []
  );
};

//------- Add Default TYPES and Categories for first time
export const addDefaultCategories = async (currentStore) => {
  // for (let i = 0; i < defaultTypes.length; i++) {
  //   const defaultType = defaultTypes[i];
  //   await ItemOrganizationService.addCustomProductType(currentStore.id, {
  //     productType: defaultType.productType,
  //     storeId: null,
  //     companyId: null,
  //     isCustom: false,
  //     isActive: true,
  //   }, currentStore.companyId ).then(
  //     (response) => {},
  //     (error) => {}
  //   );
  // }

  // const customTypes = await ItemOrganizationService.getCustomProductTypes(
  //   currentStore.id, currentStore.companyId
  // ).then(
  //   (response) => {
  //     return response.productTypes;
  //   },
  //   (error) => {}
  // );

  // const videoGameType = customTypes.find(
  //   (type) => type.productType === PRODUCT_TYPES_ENUMS.VIDEO_GAME
  // );
  // const tradingCardType = customTypes.find(
  //   (type) => type.productType === PRODUCT_TYPES_ENUMS.TRADING_CARD
  // );

  // for (let i = 0; i < defaultCategories.length; i++) {
  //   const defaultCategory = defaultCategories[i];
  //   await ItemOrganizationService.addCustomCategory(currentStore.id, {
  //     name: defaultCategory.name,
  //     storeId: null,
  //     companyId: null,
  //     productTypeId: videoGameType.id,
  //     productTypeName: videoGameType.productType,
  //     isCustom: false,
  //     isActive: true,
  //   }, currentStore.companyId ).then(
  //     (response) => {},
  //     (error) => {}
  //   );
  // }

  // for (let i = 0; i < defaultTradingCardCategories.length; i++) {
  //   const defaultCategory = defaultTradingCardCategories[i];
  //   await ItemOrganizationService.addCustomCategory(currentStore.id, {
  //     name: defaultCategory.name,
  //     storeId: null,
  //     companyId: null,
  //     productTypeId: tradingCardType.id,
  //     productTypeName: tradingCardType.productType,
  //     isCustom: false,
  //     isActive: true,
  //   }, currentStore.companyId ).then(
  //     (response) => {},
  //     (error) => {}
  //   );
  // }

  // // adding default subcategories
  // for (let i = 0; i < defaultSubCategories.length; i++) {
  //   const defaultSubCategory = defaultSubCategories[i];
  //   await ItemOrganizationService.addCustomSubCategory(currentStore.id, {
  //     name: defaultSubCategory.name,
  //     storeId: null,
  //     companyId: null,
  //     parentCategoryId: SYSTEM_SUBCATEGORY,
  //     parentCategoryName: SYSTEM_SUBCATEGORY,
  //     parentProductTypeId: videoGameType.id,
  //     parentProductTypeName: videoGameType.productType,
  //     isCustom: false,
  //     isActive: true,
  //   }, currentStore.companyId ).then(
  //     (response) => {},
  //     (error) => {}
  //   );
  // }

  // adding default tags
  const defaultTags = await inventoryService
    .addDefaultTags(currentStore.id, DEFAULT_TAGS)
    .then(
      (response) => {
        return response;
      },
      (error) => {
        console.log("Error: saving the default tags", error);
      }
    );

  customToast("categories added", toastType.SUCCESS);
};

export const getDefaultFilterType = (list, label) => {
  const foundItem = list?.find((type) => type.productType === label);
  return foundItem
    ? {
        value: foundItem.id,
        label: foundItem.productType,
      }
    : {};
};

export const getDefaultFilterCategory = (list, label) => {
  const foundItem = list?.find((type) => type.name === label);
  return foundItem
    ? {
        value: foundItem.id,
        label: foundItem.name,
      }
    : "";
};

export const getThresholdFilterList = (thresholdData) => {
  let combineFilterList = [
    ...(thresholdData?.byCategory?.map((item) => ({
      categoryId: item.categoryId,
      categoryName: item.categoryName,
      valueType: item.valueType,
      value: item.value,
      isCategory: CUSTOM_FILTER_ENUMS.BY_CATEGORY.value,
    })) || []),
    ...(thresholdData?.byPriceRange?.map((item) => ({
      min: item.min,
      max: item.max,
      value: item.value,
      isCategory: CUSTOM_FILTER_ENUMS.BY_PRICE_RANGE.value,
      valueType: item.valueType,
    })) || []),
  ];

  return combineFilterList;
};

export const handleAddBatchInventoryPark = (
  addBatchInventory,
  currentStore,
  addBatchInventoryDraftDispatch,
  successCallBack = () => {}
) => {
  addBatchInventoryDraftDispatch(
    {
      store: { id: currentStore.id, name: currentStore.storeName },
      inventory: addBatchInventory,
      quantity: addBatchInventory.reduce(
        (a, b) => a + Number(b?.inStockQuantity),
        0
      ),
      totalAmountToPay: addBatchInventory.reduce(
        (a, b) => a + Number(b?.inStockQuantity) * Number(b?.inStockPrice),
        0
      ),
    },
    successCallBack
  );
};

export const isButtonDisable = (spinnerArray, Key) => {
  return spinnerArray?.includes(Key);
};

export const encodeQueryParam = (value, specialCharacter) => {
  return value.replace(specialCharacter, "%26");
};

export const stringToBase64 = (string) => {
  const enc = new Base64();
  return enc.urlEncode(string);
};

export const updateCartLocalStorage = (key, data, storeId) => {
  // Retrieve and parse the current cart data from localStorage
  const storedData = parseJsonObject(getItemFromLocalStorage(key)) || [];

  // Check if the storeId already exists in the stored data
  const updatedData = storedData?.map((item) =>
    item.storeId === storeId ? { ...item, data: data } : item
  );

  // If storeId wasn't found, add a new entry
  if (!storedData?.some((item) => item.storeId === storeId)) {
    updatedData.push({ storeId: storeId, data: data });
  }

  // Save the updated cart data back to localStorage
  setItemToLocalStorage(key, stringifyObject(updatedData));
};

export const getStoreSaleCartDetailsFromStorage = (
  key,
  storeId,
  transactionDefaultData
) => {
  let transactionDataObject = transactionDefaultData;

  const storedSellTradeDataInLocalStorage = parseJsonObject(
    getItemFromLocalStorage(key)
  );

  if (storedSellTradeDataInLocalStorage) {
    const findCurrentStoreData = storedSellTradeDataInLocalStorage.find(
      (storedData) => storedData.storeId === storeId
    );
    transactionDataObject =
      findCurrentStoreData?.data || transactionDefaultData;
  }
  return transactionDataObject;
};

export const isSpinnerEnabled = (spinnerArray, key) => {
  // Check if key is an array
  if (Array.isArray(key)) {
    return key.some((element) => spinnerArray.includes(element));
  }

  // If key is not an array, fallback to original behavior
  return spinnerArray.includes(key);
};

export const addTimeDelay = (ms) =>
  new Promise((resolve) => setTimeout(resolve, ms));

// handleCategorySelect for tradeins margin, preset prices and discount
export const handleCategorySelect = (
  selectedCategory,
  setByFilter,
  searchCategories,
  setSearchCategories,
  selectedCategories,
  setSelectedCategories,
  filterProductCategory,
  compareIds = false
) => {
  //Do the comparison for displaying categories based on id or name
  if (compareIds) {
    //if (!selectedCategories.find((c) => c.id === selectedCategory?.id)) {
    if (setByFilter === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value) {
      // case of multiselect option for categories
      if (Array.isArray(filterProductCategory)) {
        // Multi-select
        const newSelected = filterProductCategory.map((fc) => ({
          ...selectedCategory,
          parentCategoryId: fc.value,
          parentCategoryName: fc.label,
        }));

        //if all is selected we need to remove the other selected rows for that type
        let updatedCategories = selectedCategories;
        if (
          newSelected.length > 0 &&
          newSelected[0].parentCategoryName === PRODUCT_TYPES_ENUMS.ALL
        ) {
          // Remove all with same productTypeId
          updatedCategories = selectedCategories.filter(
            (item) =>
              !(
                item.productTypeId === newSelected[0].productTypeId &&
                item.id === newSelected[0].id
              )
          );
        }
        setSelectedCategories([...updatedCategories, ...newSelected]);
      } else {
        setSelectedCategories([
          ...selectedCategories,
          {
            ...selectedCategory,
            parentCategoryId: filterProductCategory.value,
            parentCategoryName: filterProductCategory.label,
          },
        ]);
      }
    } else {
      setSelectedCategories([...selectedCategories, selectedCategory]);
    }
    setSearchCategories(
      searchCategories?.filter(
        (category) => category?.id !== selectedCategory?.id
      )
    );
    //}
  } else {
    if (!selectedCategories.find((c) => c.name === selectedCategory?.name)) {
      if (setByFilter === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value) {
        // case of multiselect option for categories
        if (Array.isArray(filterProductCategory)) {
          // Multi-select
          const newSelected = filterProductCategory.map((fc) => ({
            ...selectedCategory,
            parentCategoryId: fc.value,
            parentCategoryName: fc.label,
          }));
          setSelectedCategories([...selectedCategories, ...newSelected]);
        } else {
          setSelectedCategories([
            ...selectedCategories,
            {
              ...selectedCategory,
              parentCategoryId: filterProductCategory.value,
              parentCategoryName: filterProductCategory.label,
            },
          ]);
        }
      } else {
        setSelectedCategories([...selectedCategories, selectedCategory]);
      }
      setSearchCategories(
        searchCategories?.filter(
          (category) => category?.name !== selectedCategory?.name
        )
      );
    }
  }
};

export const prepareFilterForPaginationCall = (
  productType,
  category,
  subcategory,
  inStockFilter
) => {
  let filters = "";
  if (productType && productType?.label !== PRODUCT_TYPES_ENUMS.ALL) {
    filters = filters + `AND c.productType = "${productType.label}" `;
  }

  if (category?.label) {
    filters =
      filters + `AND c.category_name = "${category?.label || EMPTY_STRING}" `;
  }

  if (subcategory?.label) {
    filters =
      filters + `AND c.subcategory = "${subcategory?.label || EMPTY_STRING}" `;
  }

  // if the filter for in-stock/out-of-stock is applied add that to query
  if (inStockFilter?.value === INSTOCK_FILTER_OPTIONS.IN_STOCK.value) {
    filters =
      filters +
      `AND (c.trackQuantity = false OR (c.price.quantity > 0 OR (IS_DEFINED(c.price.onlineQuantity) AND c.price.onlineQuantity > 0)))  `;
  } else if (
    inStockFilter?.value === INSTOCK_FILTER_OPTIONS.OUT_OF_STOCK.value
  ) {
    filters =
      filters +
      `AND (c.trackQuantity = true AND (c.price.quantity <= 0 AND (NOT IS_DEFINED(c.price.onlineQuantity) OR c.price.onlineQuantity <= 0)))  `;
  }

  return filters;
};

export const prepareFilterForInventoryHistoryPaginationCall = (
  productType,
  category,
  transactionType,
  startDate,
  endDate,
  subcategory
) => {
  let filters = "";
  if (productType && productType?.label !== PRODUCT_TYPES_ENUMS.ALL) {
    filters = filters + `AND c.product.productType = '${productType.label}' `;
  }

  if (category?.label) {
    filters =
      filters +
      `AND c.product.category = '${category?.label || EMPTY_STRING}' `;
  }

  if (subcategory?.label) {
    filters =
      filters +
      `AND c.product.subcategory = "${subcategory?.label || EMPTY_STRING}" `;
  }

  if (
    transactionType?.label &&
    transactionType?.label !== PRODUCT_TYPES_ENUMS.ALL
  ) {
    filters = filters + `AND c.TransactionType = '${transactionType?.label}' `;
  }

  if (startDate) {
    filters = filters + `AND c.createdOn > '${startDate}' `;
  }

  if (endDate) {
    filters = filters + `AND c.createdOn < '${endDate}' `;
  }

  return filters;
};

export const prepareFilterForShopifyOrdersCall = (
  orderType,
  orderPaymentStatus,
  orderFulfillmentStatus,
  startDate,
  endDate
) => {
  let filters = "";

  if (orderType?.label && orderType?.label !== PRODUCT_TYPES_ENUMS.ALL) {
    filters = filters + `AND c.orderType = '${orderType?.label}' `;
  }

  if (
    orderPaymentStatus?.label &&
    orderPaymentStatus?.label !== PRODUCT_TYPES_ENUMS.ALL
  ) {
    filters =
      filters + `AND c.orderPaymentStatus = '${orderPaymentStatus?.label}' `;
  }

  if (
    orderFulfillmentStatus?.label &&
    orderFulfillmentStatus?.label !== PRODUCT_TYPES_ENUMS.ALL
  ) {
    filters =
      filters +
      `AND c.orderFulfillmentStatus = '${orderFulfillmentStatus?.label}' `;
  }

  if (startDate) {
    filters = filters + `AND c.createdOn > '${startDate}' `;
  }

  if (endDate) {
    filters = filters + `AND c.createdOn < '${endDate}' `;
  }

  return filters;
};

export const isAnyStockPriceUpdate = (data) => {
  return data?.some((item) => item.isProductExisted && item.isPriceChanged);
};

export const isAnyEditedProduct = (data) => {
  return data?.some(
    (item) =>
      item.labelType === NOTIFICATION_TYPES.PRODUCT_LABEL_EDIT ||
      item.labelType === NOTIFICATION_TYPES.PRODUCT_LABEL_EDIT_CONSOLIDATED
  );
};

export const isShowCheckbox = (row) => {
  return row.price.isProductExisted && row.price.isPriceChanged;
};

export const getFilteredColumns = (data, columnHeaders) => {
  let columns = columnHeaders;
  // columns = isAnyEditedProduct(data)
  //   ? columns
  //   : columns.filter((column) => column.id !== "stockQuantity");

  columns = isAnyStockPriceUpdate(data)
    ? columns
    : columns.filter((column) => column.id !== "update-all-labels");

  return columns;
};

export const createCompanyDynamicUrl = (path) => {
  const domainUrl = getItemFromLocalStorage(globalConstants.COMPANY_DOMAIN_URL);
  return domainUrl ? `/${domainUrl}${path}` : path;
};

export const getDynamicNotAllowedRoutes = (routes) => {
  return routes.map((route) => createCompanyDynamicUrl(route));
};

export const isSellTransactionhasPartialPayment = (transactionData) => {
  return getSumOfPaymentHistory(transactionData?.paymentHistory) > 0;
};

const updateCustomerData = (
  dispatch,
  storeId,
  customer,
  cartDataObject,
  setData
) => {
  if (!cartDataObject) return;

  const currentStoreCartData = cartDataObject.find(
    (storedData) => storedData.storeId === storeId
  );

  if (currentStoreCartData && currentStoreCartData?.data?.customer?.id) {
    const existingCustomer = customer;

    dispatch(
      setData(
        {
          ...currentStoreCartData.data,
          customer: getSellTradeCustomerObject(existingCustomer),
        },
        storeId
      )
    );
  }
};

export const updateCustomerCreditOnCarts = (
  dispatch,
  storeId,
  customer,
  setNewTradeData,
  setTransactionData
) => {
  const tradeCartData = parseJsonObject(
    getItemFromLocalStorage(transactionConstants.NEW_TRADE_PAGE_DATA)
  );
  const transactionCartData = parseJsonObject(
    getItemFromLocalStorage(transactionConstants.NEW_SALE_PAGE_DATA)
  );

  updateCustomerData(
    dispatch,
    storeId,
    customer,
    tradeCartData,
    setNewTradeData
  );
  updateCustomerData(
    dispatch,
    storeId,
    customer,
    transactionCartData,
    setTransactionData
  );
};

export const getSystemMarketPrice = (priceChartingProductInfo) => {
  if (
    priceChartingProductInfo.productMetaData.genre ===
    TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
  ) {
    return priceChartingProductInfo.productObject[
      inventoryConstants.LOOSE_PRICE
    ];
  } else {
    const isSkyLander = inventoryConstants.SKYLANDER_CATEGORIES.includes(
      priceChartingProductInfo.productObject[
        inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
      ]
    );

    if (isSkyLander) {
      return priceChartingProductInfo.productObject[
        inventoryConstants.NEW_PRICE
      ];
    } else {
      return priceChartingProductInfo.productObject[
        inventoryConstants.COMPLETE_IN_BOX_PRICE
      ];
    }
  }
};

export const getSystemSuggestedMarketPrice = (priceChartingProductInfo) => {
  if (
    priceChartingProductInfo.productMetaData.genre ===
    TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
  ) {
    return priceChartingProductInfo.productObject[
      inventoryConstants.RETAIL_LOOSE_PRICE
    ];
  } else {
    const isSkyLander = inventoryConstants.SKYLANDER_CATEGORIES.includes(
      priceChartingProductInfo.productObject[
        inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
      ]
    );
    if (isSkyLander) {
      return priceChartingProductInfo.productObject[
        inventoryConstants.RETAIL_NEW_PRICE
      ];
    } else {
      return priceChartingProductInfo.productObject[
        inventoryConstants.RETAIL_COMPLETE_IN_BOX_PRICE
      ];
    }
  }
};

export const getSystemNetworkAverageBuySellPrices = (
  priceChartingProductInfo
) => {
  let res = {};
  const isSkyLander = inventoryConstants.SKYLANDER_CATEGORIES.includes(
    priceChartingProductInfo.productObject[
      inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
    ]
  );
  if (
    priceChartingProductInfo.productMetaData.genre ===
    TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
  ) {
    res = {
      ...getNetworkAvgBuySellPricesAccordingCondition(
        PRODUCT_CONDITIONS_ENUMS.LOOSE,
        priceChartingProductInfo
      ),
    };
  } else if (isSkyLander) {
    res = {
      ...getNetworkAvgBuySellPricesAccordingCondition(
        PRODUCT_CONDITIONS_ENUMS.NEW,
        priceChartingProductInfo
      ),
    };
  } else {
    res = {
      ...getNetworkAvgBuySellPricesAccordingCondition(
        PRODUCT_CONDITIONS_ENUMS.COMPLETE,
        priceChartingProductInfo
      ),
    };
  }
  return res;
};

//-------onSelectedTagChange
/**
 * Runs when tags are selected or removed.
 *
 * It recalculates tag-based pricing and keeps form edits safe by using
 * PARTIAL preserve mode when preserve state is provided.
 */
export const onSelectTagsChange = (
  selectedTags,
  setSelectedTags,
  productDataObject,
  setProductDataObject,
  priceChartingProductInfo,
  productCondition,
  productType,
  preserveStateRef = null,
  preserveModeEnum = null
) => {
  // Keep user input while updating tag-driven pricing.
  if (preserveStateRef && preserveModeEnum) {
    preserveStateRef.current.mode = preserveModeEnum.PARTIAL;
    preserveStateRef.current.hasInteracted = true;
  }
  const selectedTagList = selectedTags.map((tag) => tag.label);
  changePriceBaseOnTags(
    selectedTagList,
    productDataObject,
    setProductDataObject,
    priceChartingProductInfo,
    inventoryConstants,
    PRODUCT_CONDITIONS_ENUMS,
    TRADING_CARD_CATEGORIES_ENUMS,
    productCondition,
    productType
  );
  setSelectedTags(selectedTagList);
};

export const handleProductConditionUpdate = async (
  currentStore,
  priceChartingProductInfo,
  getInventoryByPricechartingId,
  setProductType,
  setProductUrl,
  productDataObject,
  setProductDataObject,
  productTags,
  setProductTagsList,
  setRarities,
  setSelectedRarity,
  setConditionList,
  setProductCondition,
  productImage = false,
  isProductEdit = false,
  productToEdit
) => {
  if (priceChartingProductInfo?.productObject) {
    if (
      priceChartingProductInfo.productMetaData.sourceApi ===
      inventoryConstants.PRICECHARTING_API
    ) {
      if (
        priceChartingProductInfo.productMetaData.genre ===
        TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
      ) {
        setSelectedRarity("");
        setProductType(PRODUCT_TYPES_ENUMS.VIDEO_GAME);
        handleConditionsAndTags(
          priceChartingProductInfo.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
          ],
          priceChartingProductInfo.productObject["genre"],
          productTags,
          setConditionList,
          setProductCondition,
          setProductTagsList,
          inventoryConstants.VIDEO_GAME_SYSTEM_CONDITION,
          isProductEdit,
          productToEdit
        );
      } else {
        setSelectedRarity("");
        setProductType(PRODUCT_TYPES_ENUMS.VIDEO_GAME);

        handleConditionsAndTags(
          priceChartingProductInfo.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
          ],
          priceChartingProductInfo.productObject["genre"],
          productTags,
          setConditionList,
          setProductCondition,
          setProductTagsList,
          inventoryConstants.VIDEO_GAME_CONDITION,
          isProductEdit,
          productToEdit
        );
      }

      setProductDataObject({
        ...productDataObject,
        ...priceChartingProductInfo.productMetaData,
        productName:
          priceChartingProductInfo.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_NAME
          ],
        consoleName:
          priceChartingProductInfo.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
          ],
        marketPrice: getSystemMarketPrice(priceChartingProductInfo),
        suggestedSellPrice: getSystemSuggestedMarketPrice(
          priceChartingProductInfo
        ),
        gameStopBuyPrice:
          priceChartingProductInfo.productObject[
            inventoryConstants.GAMESTOP_PRICE
          ],
        networkAverageBuySellPrices: {
          ...getSystemNetworkAverageBuySellPrices(priceChartingProductInfo),
        },
        upc: priceChartingProductInfo.productObject.upc || EMPTY_STRING,
        genre: priceChartingProductInfo.productMetaData.genre,
        productId: priceChartingProductInfo.productObject.id,
        costOfGoods: 0,
        inStockPrice: 0,
        inStorePrice: 0,
        inStockQuantity: 0,
        skuNumber: [],
        averageBuyPrice: 0,
        averageSellPrice: 0,
        maxBuyPrice: 0,
        cardNumber: 0,
        tcgPlayerUrl: EMPTY_STRING,
        imgUrl: productImage || EMPTY_STRING,
        epid: priceChartingProductInfo.productObject?.epid || EMPTY_STRING,
      });
      getInventoryByPricechartingId(currentStore?.id, {
        id: priceChartingProductInfo.productObject.id,
        categoryName:
          priceChartingProductInfo.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_CONSOLE_NAME
          ],
        productName:
          priceChartingProductInfo.productObject[
            inventoryConstants.PRICECHARTING_PRODUCT_NAME
          ],
      });
    } else if (
      priceChartingProductInfo.productMetaData.sourceApi ===
      inventoryConstants.TCG_PLAYER_API
    ) {
      getInventoryByPricechartingId(currentStore?.id, {
        id: priceChartingProductInfo.productObject.id,
        categoryName: priceChartingProductInfo.productMetaData.consoleName,
        productName: priceChartingProductInfo.productMetaData.productName,
      });
      // In order to update values in priceChartingProductInfo head over to handleMapTcgObjectToDbJson function
      setProductDataObject(priceChartingProductInfo.productMetaData);
      setSelectedRarity(priceChartingProductInfo.productMetaData.cardRarity);
      setRarities(priceChartingProductInfo.productMetaData.cardRarityList);
      setProductType(priceChartingProductInfo.productMetaData.productType);
      setProductCondition(priceChartingProductInfo.productMetaData.condition);
      setConditionList(priceChartingProductInfo.productMetaData.conditionList);
    }
  }
  setProductUrl("");
};

export const getReceiptPrintDate = (dateString, onlyDate = false) => {
  // return new Date(date).toLocaleString("en-US", {
  //   year: "2-digit",
  //   month: "2-digit",
  //   day: "2-digit",
  //   hour: "2-digit",
  //   minute: "2-digit",
  //   second: "2-digit",
  //   hour12: true,
  // });
  if (!dateString) {
    return EMPTY_STRING;
  }

  const date = formatDate(dateString);
  const time = formatTime(dateString);

  if (onlyDate) {
    return `${date}`;
  }
  return `${date} - ${time}`;
};

export const createMappedArray = (
  csvData,
  predefinedColumns,
  columnMapping
) => {
  return csvData.map((row) => {
    const mappedRow = {};
    predefinedColumns.forEach((predefinedColumn) => {
      const csvColumn = columnMapping[predefinedColumn];
      if (csvColumn && row.hasOwnProperty(csvColumn)) {
        mappedRow[predefinedColumn] = row[csvColumn];
      }
    });
    return mappedRow;
  });
};

export const handleColumnMapping = (
  predefinedColumn,
  selectedCsvColumn,
  setColumnMapping
) => {
  setColumnMapping((prevMapping) => ({
    ...prevMapping,
    [predefinedColumn]: selectedCsvColumn,
  }));
};

export const handleFileLoaded = (
  data,
  fileInfo,
  predefinedColumns,
  setCsvData,
  setColumnMapping
) => {
  // handle empty file
  if (!data.length) {
    customToast(toastMessages.NO_RECORD_FOUND, toastType.ERROR);
    return;
  }
  if (fileInfo.type === "text/csv") {
    const defaultMapping = {};
    const csvColumns = Object.keys(data[0]);

    csvColumns.forEach((csvColumn) => {
      if (predefinedColumns.includes(csvColumn)) {
        defaultMapping[csvColumn] = csvColumn;
      }
    });
    setCsvData(data);
    setColumnMapping(defaultMapping);
  } else {
    customToast(toastMessages.ONLY_CSV_ALLOWED, toastType.ERROR);
  }
};

export const isProductMetaDataSame = (
  product1,
  product2,
  isSerialNumber = true
) => {
  let isSame =
    String(product1.product_name).toLowerCase() ===
      String(product2.product_name).toLowerCase() &&
    String(product1.category_name).toLowerCase() ===
      String(product2.category_name).toLowerCase() &&
    String(product1.subcategory).toLowerCase() ===
      String(product2.subcategory).toLowerCase() &&
    product1.price.type === product2.price.type &&
    isTagsEqual(product1.tags, product2.tags) &&
    product1.cardRarity === product2.cardRarity &&
    product1.productType === product2.productType;
  if (isSerialNumber) {
    isSame = isSame && product1.serialNumber === product2.serialNumber;
  }
  if (product1.price.grade || product2.price.grade) {
    isSame = isSame && product1.price.grade === product2.price.grade;
  }
  return isSame;
};

export const beautifyStringForImport = (value) => {
  if (value == null) return "";

  let str = String(value);

  // Normalize problematic characters
  str = str
    .replace(/\r?\n|\r/g, " ") // remove new lines
    .replace(/\t/g, " ") // remove tabs
    .replace(/\s+/g, " ") // collapse multiple spaces
    .trim();

  // Escape double quotes (CSV standard)
  str = str.replace(/"/g, '""');

  // Always wrap in quotes to be safe
  return `"${str}"`;
};

export const isPriceChanged = (arr1, arr2) => {
  return arr1.some((item1) => {
    const item2 = arr2.find((item) => item.id === item1.id);
    return item2 && item1.price.unit_sell_price !== item2.price.unit_sell_price;
  });
};

export const getProductLabelNotifications = (notificationsArr) => {
  return notificationsArr?.length
    ? notificationsArr?.filter(
        (notfication) =>
          notfication.type === NOTIFICATION_TYPES.PRODUCT_LABEL ||
          notfication.type === NOTIFICATION_TYPES.PRODUCT_LABEL_EDIT ||
          notfication.type ===
            NOTIFICATION_TYPES.PRODUCT_LABEL_EDIT_CONSOLIDATED
      )
    : [];
};

export const handleIsLabelNotificationOnEditInventory = (
  editInventoryResponse,
  isLabelNotification
) => {
  return (
    editInventoryResponse.data?.data?.isLabelNotification && isLabelNotification
  );
};

export const isTradeTransaction = (transaction) => {
  return transaction?.id
    ? transaction?.id.startsWith(globalConstants.TYPE_ID_TRD)
    : false;
};

export const isSaleTransaction = (transaction) => {
  return transaction?.id
    ? transaction?.id.startsWith(globalConstants.TYPE_ID_TRA)
    : false;
};

export const isReturnTransaction = (transaction) => {
  return transaction?.id
    ? transaction?.id.startsWith(globalConstants.TYPE_RETURN)
    : false;
};

export const calculateTransactionTaxPercentage = (transaction) => {
  return +Number(
    (parseToNumber(transaction.Tax) / parseToNumber(transaction.SubTotal)) * 100
  ).toFixed(2);
};

//-------- handle uplaod image
export const handleUploadProductImage = (
  e,
  activateSpinner,
  deactivateSpinner,
  productDataObject,
  setProductDataObject,
  resizeImage = { isResize: false, newWidth: 200 }
) => {
  let file = e.target.files[0];
  if (file) {
    if (
      file.type === IMAGE_FILE_TYPES.PNG ||
      file.type === IMAGE_FILE_TYPES.JPEG ||
      file.type === IMAGE_FILE_TYPES.JPG
    ) {
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            activateSpinner(inventoryConstants.UPLOAD_IMAGE);
            if (resizeImage.isResize) {
              file = await resizeImageBlob(file, resizeImage.newWidth);
            }
            const productImage = await uploadCustomProductImage(file);
            setProductDataObject({
              ...productDataObject,
              imgUrl: productImage,
            });
            deactivateSpinner(inventoryConstants.UPLOAD_IMAGE);
          };
        };
        reader.readAsDataURL(file);
      }
    } else {
      customToast(
        "Only .jpg, .jpeg and .png files are allowed",
        toastType.ERROR
      );
      e.target.value = null;
    }
  }
};
export const isDateInTimeRange = (timeFrame) => {
  const { start, end, duration } = timeFrame;

  const startDate = new Date(start);
  const endDate = new Date(end);
  const currentDate = new Date();

  const currentMonth = currentDate.getMonth();
  const endMonth = endDate.getMonth();

  if (duration === datepickerConstants.DAILY) {
    return currentDate <= endDate && currentDate >= startDate;
  } else if (duration === datepickerConstants.MONTHLY) {
    return currentMonth === endMonth;
  } else {
    return false;
  }
};

export const calculateBarWidth = (max, current) => {
  if (max === 0) {
    return 0;
  }

  const percentage = (current / max) * 100;

  return Math.max(0, Math.min(percentage, 100));
};

export const NoDataWrapper = () => {
  return (
    <div className="d-flex justify-content-center align-items-center flex-column no-graph-data-wrapper category-data-found">
      <p>No data to show.</p>
      <p>Try selecting a different date range</p>
    </div>
  );
};

//------- Round off values to show 1000 into 1k
export const formatValueToThousand = (value, currency = false) => {
  if (value > 999.99) {
    return `${currency || ""}${Math.round(value / 100) / 10}K`; // Rounds to one decimal place and adds 'K'
  } else {
    return `${currency || ""}${value}`; // For values less than 1000, show with two decimal places
  }
};
export const formatCurrency = (
  value,
  showSign = false,
  isCommaSeparate = true
) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "$0.00";
  }

  const numValue = Number(value);
  const isNegative = numValue < 0;
  const absValue = Math.abs(numValue);

  const formatted = isCommaSeparate
    ? absValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : absValue.toFixed(2);

  if (isNegative) {
    return `-$${formatted}`;
  }

  if (showSign && numValue > 0) {
    return `+$${formatted}`;
  }

  return `$${formatted}`;
};

export const formatPercentage = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "0.00%";
  }
  return `${Number(value).toFixed(2)}%`;
};

export const calculateRatio = (item, isTradeCart = false) => {
  if (isTradeCart) {
    return (
      item?.tradeProductMetaData?.tradeInMarginTypeObject?.marginObject
        ?.tradeinMarginPercentage /
      item?.tradeProductMetaData?.tradeInMarginTypeObject?.marginObject
        ?.cashMarginPercentage
    );
  } else {
    return (
      item?.tradeInMarginTypeObject?.marginObject?.tradeinMarginPercentage /
      item?.tradeInMarginTypeObject?.marginObject?.cashMarginPercentage
    );
  }
};

export const roundNumber = (number) => {
  return Number(Math.round(Number(number) * 1e2) / 1e2) || 0;
};

export const handleCalculateTotalCogsAndStockPrice = (
  filteredInventory,
  isTrade = false
) => {
  let initialTotalCogs = 0;
  let initialTotalStockPrice = 0;
  filteredInventory.forEach((item) => {
    // calculate total cogs and total stock price
    initialTotalCogs = isTrade
      ? roundNumber(
          Number(initialTotalCogs) +
            Number(item?.price?.unit_purchase_price) *
              Number(item?.price?.quantity)
        )
      : roundNumber(
          Number(initialTotalCogs) + Number(item.cogs) * Number(item.quantity)
        );
    initialTotalStockPrice = isTrade
      ? roundNumber(
          Number(initialTotalStockPrice) +
            Number(item?.price?.unit_sell_price) * Number(item?.price?.quantity)
        )
      : roundNumber(
          Number(initialTotalStockPrice) +
            Number(item.actualPrice) * Number(item.quantity)
        );
  });
  return { initialTotalCogs, initialTotalStockPrice };
};

//------- Validate Every System has Serial Number if Required
export const isAllSystemHasSerialNumber = (currentStore, addBatchInventory) => {
  if (
    currentStore?.[
      toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY
    ]
  ) {
    return addBatchInventory.some((inv) => {
      return (
        getProductSubCategory(inv.genre) ===
          TRADING_CARD_CATEGORIES_ENUMS.SYSTEM && !inv.serialNumber
      );
    });
  }
};

//------ check product subcategory is system
export const isSystemProduct = (subCategory) => {
  return subCategory === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM;
};

//------ check product serial number is unique
export const isSerialNumberUnique = (serialNumber, products) => {
  //------ Check if the serial number already exists in the products array
  return !products.some(
    (product) =>
      product?.serialNumber &&
      serialNumber &&
      product.serialNumber === serialNumber
  );
};

//------ get sum of all instock products
export const getTotalNumberOfInStockProducts = (
  findProduct,
  isSeparateQuantity = false
) => {
  return findProduct?.reduce((sum, product) => {
    return (
      sum +
      (isSeparateQuantity
        ? product?.price?.onlineQuantity || 0
        : product?.price?.quantity || 0)
    ); // Add quantity if it exists, otherwise add 0
  }, 0);
};

//------- get products if found in stock
export const isProductsExistInStock = (
  condition,
  selectedTags,
  selectedRarity,
  inventoryProducts,
  priceChartingProductInfo
) => {
  if (!inventoryProducts || inventoryProducts.length === 0) {
    return [];
  }
  let productDataObject = priceChartingProductInfo?.productMetaData
    ? priceChartingProductInfo.productMetaData
    : priceChartingProductInfo;
  if (typeof productDataObject.price === "object") {
    productDataObject = { ...productDataObject, ...productDataObject.price };
  }

  return (
    inventoryProducts
      .filter((product) => {
        if (
          product.price.type === condition &&
          isTagsEqual(product.tags || [], selectedTags || [])
        ) {
          if (
            productDataObject?.sourceApi === inventoryConstants.TCG_PLAYER_API
          ) {
            if (
              (product.cardRarity === selectedRarity ||
                (!product.cardRarity && !selectedRarity)) &&
              (!product.price.grade ||
                product.price.grade === productDataObject?.grade)
            ) {
              return product;
            }
          } else {
            return product;
          }
        }
      })
      // if extisting product belongs to company's other store and not the current store then only populate sell price
      .map((product) => {
        let updatedProduct = product;
        if (productDataObject?.currentStore?.id !== product.store.id) {
          updatedProduct = {
            imgUrl: updatedProduct.imgUrl,
            price: {
              unit_sell_price: updatedProduct?.price?.unit_sell_price ?? 0,
              onlineUnitSellPrice:
                updatedProduct?.price?.onlineUnitSellPrice ?? 0,
              quantity: updatedProduct?.price?.quantity ?? 0,
              onlineQuantity: updatedProduct?.price?.onlineQuantity ?? 0,
            },
          };
        }
        return updatedProduct;
      })
  );
};

// assign values to product data object based on existing versions and if not existing then default value
export const handlePrepareProductDataObject = (
  prevProductDataObject,
  dbVersionToUseAsValues,
  dbExistingProducts,
  tempShopifySettingObject,
  productType,
  marketPrice,
  markupPresets,
  calculateCOG,
  newMarketPriceAfterPreset
) => {
  const shopifySettingId =
    tempShopifySettingObject?.marginObject?.id || EMPTY_STRING;
  const isLinkToShopify =
    tempShopifySettingObject?.marginObject?.isLinkToShopify || false;
  const isOnlineQuantity =
    tempShopifySettingObject?.marginObject?.isOnlineQuantity || false;
  const isOnlineUnitSellPrice =
    tempShopifySettingObject?.marginObject?.isOnlineUnitSellPrice || false;
  const unitSellPrice = dbVersionToUseAsValues?.price?.unit_sell_price ?? 0;

  return {
    skuNumber: dbVersionToUseAsValues?.sku || [],
    imgUrl:
      dbVersionToUseAsValues?.imgUrl ||
      prevProductDataObject.imgUrl ||
      EMPTY_STRING,
    inStockQuantity: getTotalNumberOfInStockProducts(dbExistingProducts) || 0,
    onlineInStockQuantity:
      getTotalNumberOfInStockProducts(dbExistingProducts, true) || 0,
    inStorePrice: unitSellPrice,
    costOfGoods: calculateCOG(newMarketPriceAfterPreset),
    averageBuyPrice: dbVersionToUseAsValues?.price?.averageBuyPrice || 0,
    averageSellPrice: dbVersionToUseAsValues?.price?.averageSellPrice,
    maxBuyPrice: dbVersionToUseAsValues?.price?.maxBuyPrice || 0,
    totalUnitsSold: dbVersionToUseAsValues?.price?.totalUnitsSold || 0,
    maxCash: dbVersionToUseAsValues?.price?.maxCash || 0,
    maxTrade: dbVersionToUseAsValues?.price?.maxTrade || 0,
    isLinkToShopify:
      dbVersionToUseAsValues?.isLinkToShopify === undefined
        ? isLinkToShopify
        : dbVersionToUseAsValues?.isLinkToShopify,
    shopifyId: `${dbVersionToUseAsValues?.shopifyId || EMPTY_STRING}`,
    variantId: `${dbVersionToUseAsValues?.variantId || EMPTY_STRING}`,
    shopifySettingId:
      dbVersionToUseAsValues?.shopifySettingId || shopifySettingId,
    shopifyInventoryItemId:
      dbVersionToUseAsValues?.shopifyInventoryItemId || EMPTY_STRING,
    inStockPrice:
      unitSellPrice ||
      getPresetStockPrice(
        productType,
        marketPrice,
        markupPresets,
        prevProductDataObject
      ) ||
      0, //priority is db product sell price -> then market price based on store settings
    onlineUnitSellPrice:
      dbVersionToUseAsValues?.price?.onlineUnitSellPrice ||
      getPresetStockPrice(
        productType,
        marketPrice,
        markupPresets,
        prevProductDataObject
      ) ||
      0,
    isOnlineUnitSellPrice:
      dbVersionToUseAsValues?.price?.isOnlineUnitSellPrice === undefined
        ? isOnlineUnitSellPrice
        : dbVersionToUseAsValues?.price?.isOnlineUnitSellPrice,
    isOnlineQuantity:
      dbVersionToUseAsValues?.price?.isOnlineQuantity === undefined
        ? isOnlineQuantity
        : dbVersionToUseAsValues?.price?.isOnlineQuantity ?? false,
    onlineQuantity: 0,
    onlineUnitPurchasePrice:
      dbVersionToUseAsValues?.price?.onlineUnitPurchasePrice || 0,
    barcode: dbVersionToUseAsValues?.barcode || EMPTY_STRING,
  };
};

//------set state values if new product, local edited product, found in in stock of current store inventory, or found in stock of company inventory (used in: all trade modals of single product and AddInventoryItem Modal)
export const findInventoryProductDetail = async (
  currentStore,
  condition,
  productType,
  markupPresets,
  tradeinMargin,
  selectedTags,
  selectedRarity,
  productDataObject,
  inventoryProducts,
  setProductDataObject,
  priceChartingProductInfo,
  setPriceChartingProductInfo = () => {},
  localEditedProduct = null,
  shopifyPresets = {
    shopifySettings: [],
    getShopifyMappingsById: () => {},
    productShopifySettings: {},
    setProductShopifySettings: () => {},
  },
  modalType = null
) => {
  //-------helper functions
  let handleGetDefaultShopifySettings = () => {
    return getDefaultShopifySettings(
      handleBeautifyMarketPrice(productDataObject),
      shopifyPresets?.shopifySettings,
      productType,
      {
        ...productDataObject,
        tags: selectedTags,
        condition,
        cardRarity: productDataObject.cardRarity || EMPTY_STRING,
        subcategory: getProductSubCategory(
          productDataObject?.genre || productDataObject?.subcategory
        ),
      }
    );
  };
  const updateProductDataObject = (updateFn) => {
    setProductDataObject((prev) => {
      const updated = updateFn(prev);
      setTimeout(() => {
        if (
          modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_BATCH_TRADE_MODAL
        ) {
          setPriceChartingProductInfo({
            ...priceChartingProductInfo,
            productMetaData: updated,
          });
        }
        // if new shopify setting id is different then refetch the productShopifySettings
        if (
          isShopifyConnected(currentStore) &&
          (shopifyPresets?.productShopifySettings?.marginObject?.id !==
            updated.shopifySettingId ||
            !updated.shopifySettingId ||
            !shopifyPresets?.productShopifySettings?.marginObject?.id)
        ) {
          shopifyPresets.getShopifyMappingsById(
            currentStore.id,
            updated.shopifySettingId
          );
        }
      }, 0);
      return updated;
    });
  };
  // shopify preset values
  const tempShopifySettingObject = handleGetDefaultShopifySettings();
  const shopifySettingId = tempShopifySettingObject?.marginObject?.id;
  // cogs, stock price, market price values
  const marketPrice =
    modalType !== INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_BATCH_INVENTORY_MODAL &&
    productType === PRODUCT_TYPES_ENUMS.VIDEO_GAME
      ? convertToUsd(productDataObject.marketPrice)
      : productDataObject.marketPrice;
  const newMarketPriceAfterPreset = currentStore?.[
    toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
  ]
    ? getPresetStockPrice(
        productType,
        marketPrice,
        markupPresets,
        productDataObject
      )
    : marketPrice;
  const tradeInMarginToApply = getMarginDropdownValue(
    marketPrice,
    tradeinMargin,
    productType,
    {
      ...productDataObject,
      tags: selectedTags,
      condition,
      cardRarity: selectedRarity || EMPTY_STRING,
      subcategory: getProductSubCategory(
        productDataObject.genre,
        productDataObject
      ),
    }
  );
  const calculateCOG = (price) => {
    const { cashOffer } = calculateOfferPrices(
      price,
      tradeInMarginToApply.marginObject,
      tradeInMarginToApply.marginObject.cashMarginPercentage,
      tradeInMarginToApply.marginObject.tradeinMarginPercentage
    );
    return parseToDecimalNumber(cashOffer);
  };
  const findProduct = inventoryProducts?.length
    ? isProductsExistInStock(
        condition,
        selectedTags,
        selectedRarity,
        inventoryProducts,
        productDataObject
      )
    : [];
  const firstProduct = findProduct.length ? findProduct[0] : {};
  const unitSellPrice = firstProduct?.price?.unit_sell_price || 0;
  const marketPriceToUse = currentStore?.[
    toggleSwitchButtonConstants.ALWAYS_USE_STOCK_PRICE_FOR_COGS
  ]
    ? unitSellPrice
    : Math.min(unitSellPrice, newMarketPriceAfterPreset);

  if (localEditedProduct) {
    updateProductDataObject((prev) => {
      let updatedValue = {
        ...localEditedProduct,
        ...prev,
        //making sure in trade cart edit modal we use the db version values for some values (sku in cart is auto generated but in modal we want to show the existing versions sku)
        ...handlePrepareProductDataObject(
          prev,
          firstProduct,
          findProduct,
          tempShopifySettingObject,
          productType,
          marketPrice,
          markupPresets,
          calculateCOG,
          newMarketPriceAfterPreset
        ),
      };
      // in case of edit the following values we want to use instead of the values for a db existing version
      if (
        modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_BATCH_TRADE_MODAL ||
        modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_TRADE_CART ||
        modalType === INVENTORY_MODAL_TYPES.EDIT_FROM_ADD_BATCH_INVENTORY_MODAL
      ) {
        updatedValue = {
          ...updatedValue,
          barcode: localEditedProduct.barcode,
          inStockPrice: localEditedProduct.price.unit_sell_price,
          isLinkToShopify: localEditedProduct.isLinkToShopify,
          shopifySettingId: localEditedProduct.shopifySettingId,
          isOnlineQuantity: localEditedProduct.price.isOnlineQuantity,
          isSeparateQuantity:
            localEditedProduct.price?.isSeparateQuantity ??
            localEditedProduct.price.isOnlineQuantity,
        };
      }
      return updatedValue;
    });
  } else if (findProduct.length > 0) {
    updateProductDataObject((prev) => ({
      ...prev,
      ...handlePrepareProductDataObject(
        prev,
        firstProduct,
        findProduct,
        tempShopifySettingObject,
        productType,
        marketPrice,
        markupPresets,
        calculateCOG,
        newMarketPriceAfterPreset
      ),
      costOfGoods: calculateCOG(marketPriceToUse),
    }));
  } else {
    let updatedShopifySettingId = await handleGetDbProductMergedShopifySettings(
      currentStore,
      inventoryProducts,
      productDataObject,
      shopifySettingId,
      handleGetDefaultShopifySettings()
    );
    updateProductDataObject((prev) => {
      let updatedValues = {
        ...prev,
        ...handlePrepareProductDataObject(
          prev,
          firstProduct,
          findProduct,
          tempShopifySettingObject,
          productType,
          marketPrice,
          markupPresets,
          calculateCOG,
          newMarketPriceAfterPreset
        ),
        shopifySettingId: updatedShopifySettingId,
      };
      return updatedValues;
    });
  }
};

// Function to parse the scanned data into a structured format
const parseSortedLicenseData = (data) => {
  const fields = data.split(",");
  return {
    licenseNumber: fields[0] || "",
    firstName: fields[1] || "",
    lastName: fields[2] || "",
    address: (fields[3] || "") + (fields[4] ? " " + fields[4] : ""),
    city: fields[5] || "",
    state: fields[6] || "",
    zipCode: fields[7] || "",
    dateOfBirth: fields[8] || "",
    weight: fields[9] ? parseInt(fields[9], 10) : null,
    height: fields[10] ? parseInt(fields[10], 10) : null,
    gender: fields[11] || "",
    eyeColor: fields[12] || "",
    expirationDate: fields[13] || null,
  };
};

export const parseLiscenceScannedData = (data, IsExpired) => {
  const substrings = customerConstants.DRIVING_LICENSE_SUBSTRING;
  const validateSubstrings = customerConstants.VALIDATE_SUBSTRING;

  // Check if the required substrings are present in the data
  const missingSubstrings = validateSubstrings.filter((substring) => {
    if (data.includes(substring)) return false; // If primary is found, no need to check further
    const alternate = customerConstants.ALTERNATE_SUBSTRINGS[substring];
    return !alternate || !data.includes(alternate); // If alternate exists but is also missing, mark it as missing
  });

  // If there are missing substrings, return immediately
  if (missingSubstrings.length > 0) {
    if (customerConstants.EXPECTED_LICENSE_SECOND_FORMAT.test(data)) {
      return {
        isDataParsed: true,
        data: parseSortedLicenseData(data), // Return structured data even if parsing is not performed
        isDataSorted: true,
        missingSubstrings: missingSubstrings,
      };
    }

    customToast(toastMessages.ID_NOT_RECOGNIZED, toastType.ERROR);
    return {
      isDataParsed: false,
      data: toastMessages.ID_NOT_RECOGNIZED,
      missingSubstrings: missingSubstrings, // Return the missing substrings
    };
  }

  // Iterate over each substring and add a newline before it in the input data
  substrings.forEach((substring) => {
    // Replace the substring with itself prefixed by a newline
    data = data.replace(new RegExp(`(${substring})`, "g"), `\n$1`);
  });

  // Check if the data is expired
  if (IsExpired(data)) {
    customToast(toastMessages.ID_IS_EXPIRED, toastType.ERROR);
    return {
      isDataParsed: false,
      data: toastMessages.ID_IS_EXPIRED,
      missingSubstrings: missingSubstrings,
    };
  }

  return {
    isDataParsed: true,
    data: data,
    missingSubstrings: missingSubstrings,
  };
};

//------- handle customer license scan error
export const handleCustomerLicenseScanError = (
  user,
  errors,
  logErrors,
  currentStore
) => {
  logErrors({
    type: LOGS_TYPES.CUSTOMER_LICENSE_SCAN_LOGS,
    errors: `${errors}`,
    metaData: `Store Name: ${currentStore?.storeName}, User Email: ${user.email}, Error Screen URL: ${window.location.href}`,
  });
};

export const capitalizeEveryWord = (str) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const isProductSystemWithSerialNumber = (product) => {
  return (
    product?.serialNumber?.length > 0 &&
    product.subcategory === TRADING_CARD_CATEGORIES_ENUMS.SYSTEM
  );
};

export const getAllDefaultTags = (productTagsList) => {
  return [
    ...(productTagsList?.systemsDefaultTags?.complete || []),
    ...(productTagsList?.systemsDefaultTags?.loose || []),
    ...(productTagsList?.systemsDefaultTags?.boxOnly || []),
    ...(productTagsList?.gamesDefaultTags?.complete || []),
    ...(productTagsList?.gamesDefaultTags?.loose || []),
    ...(productTagsList?.gamesDefaultTags?.boxOnly || []),
    ...(productTagsList?.gamesDefaultTags?.manualOnly || []),
  ].reduce((acc, value) => {
    if (!acc.includes(value)) {
      acc.push(value);
    }
    return acc;
  }, []);
};

export const isCustomTagsIncluded = (productTagsList, selectedTags) => {
  const defaultTags = getAllDefaultTags(productTagsList);

  const hasCustomTag = selectedTags.some((tag) => !defaultTags.includes(tag));

  return hasCustomTag;
};

//------- Check Market Price Hign than instock price or not
export const isMarketPriceHigh = (
  marketPrice,
  stockPrice,
  productTags,
  selectedTags,
  isDataFetching = false,
  isStoreCustomProduct = false
) => {
  return (
    (isStoreCustomProduct ||
      !isCustomTagsIncluded(productTags, selectedTags)) &&
    Number(marketPrice) > Number(stockPrice) &&
    !isDataFetching
  );
};

export const getRowId = (params) => params.data.id;

export const getRowStyle = (params) => {
  if (params.node && params.node.editing) {
    return { backgroundColor: "#000000" };
  }
  return null;
};

export const getPaginationFilterParamsFromGridState = (gridState) => {
  return `search=${gridState.searchQuery}&pageSize=${
    gridState.pageSize
  }&pageNumber=${gridState.pageIndex}&filters=${stringToBase64(
    gridState.filters
  )}&sortFilter=${stringToBase64(gridState.sortFilter)}`;
};

export const getCustomerFullName = (customer, isPutDashIfNull = false) => {
  const firstName = customer?.firstName || customer?.first_name;
  const lastName = customer?.lastName || customer?.last_name;
  if (isPutDashIfNull && !firstName) {
    return "-";
  } else {
    return (firstName ?? "Customer") + " " + (lastName ?? "Name");
  }
};

export const getUserFullName = (user) => {
  return String(
    `${user?.firstName || EMPTY_STRING} ${user?.lastName || EMPTY_STRING}`
  ).trim();
};

export const getIsShowCustomerScanButton = (driverLicenseIdType) => {
  return driverLicenseIdType
    ? driverLicenseIdType === customerConstants.ID_TYPES[0].value
    : true;
};

export const getNetworkAvgBuySellPriceAccordingToSelectedRange = (
  range,
  type,
  networkAverageBuySellPrices
) => {
  let res = 0;
  if (networkAverageBuySellPrices) {
    switch (type) {
      case NETWORK_AVERAGE_PRICE_TYPES.BUY_PRICE:
        if (range === NETWORK_AVERAGE_PRICE_RANGES[0].label) {
          res = networkAverageBuySellPrices.threeMonthsAverageBuyPrice;
        } else if (range === NETWORK_AVERAGE_PRICE_RANGES[1].label) {
          res = networkAverageBuySellPrices.sixMonthsAverageBuyPrice;
        } else if (range === NETWORK_AVERAGE_PRICE_RANGES[2].label) {
          res = networkAverageBuySellPrices.twelveMonthsAverageBuyPrice;
        } else if (range === NETWORK_AVERAGE_PRICE_RANGES[3].label) {
          res = networkAverageBuySellPrices.allTimeAverageBuyPrice;
        }
        break;
      case NETWORK_AVERAGE_PRICE_TYPES.SELL_PRICE:
        if (range === NETWORK_AVERAGE_PRICE_RANGES[0].label) {
          res = networkAverageBuySellPrices.threeMonthsAverageSellPrice;
        } else if (range === NETWORK_AVERAGE_PRICE_RANGES[1].label) {
          res = networkAverageBuySellPrices.sixMonthsAverageSellPrice;
        } else if (range === NETWORK_AVERAGE_PRICE_RANGES[2].label) {
          res = networkAverageBuySellPrices.twelveMonthsAverageSellPrice;
        } else if (range === NETWORK_AVERAGE_PRICE_RANGES[3].label) {
          res = networkAverageBuySellPrices.allTimeAverageSellPrice;
        }
        break;
    }
  }
  return res;
};

export const getNetworkAvgBuySellPricesAccordingCondition = (
  condition,
  priceChartingProductInfo
) => {
  let { productObject } = priceChartingProductInfo;
  let res = {
    threeMonthsAverageBuyPrice: 0,
    threeMonthsAverageSellPrice: 0,
    sixMonthsAverageBuyPrice: 0,
    sixMonthsAverageSellPrice: 0,
    twelveMonthsAverageBuyPrice: 0,
    twelveMonthsAverageSellPrice: 0,
    allTimeAverageBuyPrice: 0,
    allTimeAverageSellPrice: 0,
  };
  const getPropertyName = (initial) => {
    return initial + condition.replaceAll(" ", EMPTY_STRING);
  };
  res = {
    threeMonthsAverageBuyPrice:
      productObject[getPropertyName("threeMonthsAverageBuyPrice")] || 0,
    threeMonthsAverageSellPrice:
      productObject[getPropertyName("threeMonthsAverageSellPrice")] || 0,
    sixMonthsAverageBuyPrice:
      productObject[getPropertyName("sixMonthsAverageBuyPrice")] || 0,
    sixMonthsAverageSellPrice:
      productObject[getPropertyName("sixMonthsAverageSellPrice")] || 0,
    twelveMonthsAverageBuyPrice:
      productObject[getPropertyName("twelveMonthsAverageBuyPrice")] || 0,
    twelveMonthsAverageSellPrice:
      productObject[getPropertyName("twelveMonthsAverageSellPrice")] || 0,
    allTimeAverageBuyPrice:
      productObject[getPropertyName("allTimeAverageBuyPrice")] || 0,
    allTimeAverageSellPrice:
      productObject[getPropertyName("allTimeAverageSellPrice")] || 0,
  };

  return res;
};

//------is payment complete with only store credit and not tax include
const isStoreCreditPayment = (transactionData) => {
  return (
    transactionData?.totalAmountToPay -
      getSumOfPaymentHistory(transactionData?.paymentHistory) !==
      0 && transactionData?.TransactionType === transactionConstants.PROCESSED
  );
};

export const isTransactionCompleteWithStoreCredit = (transaction) => {
  return isStoreCreditPayment(transaction) ? (
    <div className="d-flex justify-content-between align-items-center w-100 mt-1">
      <div className="d-flex align-items-center gap-2">
        <span className="subtotal-heading">Store Credit payment</span>
      </div>
      <span className="payment-cart-productname">
        $
        {parseToThousandSeperatorDecimalNumber(
          transaction?.paymentHistory.totalPaidAmount[
            transactionConstants.STORE_CREDIT
          ]
        )}
      </span>
    </div>
  ) : (
    EMPTY_STRING
  );
};

//------- is product tracking is enabled or not
export const isProductTrackQuantity = (product) => {
  if (
    product.trackQuantity ||
    product.trackQuantity === undefined ||
    product.trackQuantity === null
  ) {
    return true;
  } else return product.trackQuantity;
};

//------ check screensize less then 1440
export const isScreenLessThan1440 = (screenWidth) => {
  return screenWidth < 1900;
};

//------- show shopify icon
export const getHistoryOutletName = (outletName) => {
  if (
    outletName?.trim().replace(/\s+/g, "").toLowerCase() ===
    globalConstants.SHOPIFY.toLowerCase().replace(/\s+/g, "")
  ) {
    return (
      <>
        {outletName}
        <ShopifySingleIcon />
      </>
    );
  } else if (
    outletName?.trim().replace(/\s+/g, "").toLowerCase() ===
    outletConstants.NOT_CONFIGURED.toLowerCase()
  ) {
    return "-";
  } else {
    return outletName || "-";
  }
};

export const getTimeFrame = (value, timeFrame, setTimeFrame) => {
  setTimeFrame({
    ...timeFrame,
    start: moment
      .utc(value.start)
      .format(datepickerConstants.DATE_TIME_PICKER_DEFAULT_FORMAT),
    end: moment
      .utc(value.end)
      .format(datepickerConstants.DATE_TIME_PICKER_DEFAULT_FORMAT),
    duration: value?.duration,
  });
};

export const upsertEditedItemToLocalStorage = (updatedRows, key) => {
  let existingItems = [];

  try {
    const stored = getItemFromLocalStorage(key);
    existingItems = stored ? JSON.parse(stored) : [];
  } catch (e) {
    existingItems = [];
  }

  // Normalize to array
  const rowsArray = Array.isArray(updatedRows) ? updatedRows : [updatedRows];

  rowsArray.forEach((updatedRow) => {
    const index = existingItems.findIndex((item) => item.id === updatedRow.id);

    if (index > -1) {
      existingItems[index] = updatedRow;
    } else {
      existingItems.push(updatedRow);
    }
  });

  setItemToLocalStorage(key, JSON.stringify(existingItems));
};

export const getDurationString = (startDate, endDate) => {
  if (!startDate) return "0 mins";

  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date();

  let diffMs = end - start; // difference in milliseconds
  if (diffMs < 0) diffMs = 0;

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  diffMs -= diffDays * (1000 * 60 * 60 * 24);

  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  diffMs -= diffHours * (1000 * 60 * 60);

  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  let result = "";
  if (diffDays > 0) result += `${diffDays} days `;
  if (diffHours > 0) result += `${diffHours} hrs `;
  if (diffMinutes > 0) result += `${diffMinutes} mins`;

  return result.trim() || "0 mins";
};

export const getStoreLogo = async (
  currentStore,
  dpi = printerConstants.DEFAULT_DPI
) => {
  if (!currentStore?.logo) {
    customToast(toastMessages.STORE_LOGO_NOT_FOUND, toastType.ERROR);
  }

  const downloadedImage = await downloadImage(currentStore?.logo);
  const resizedImage = await resizeAndDarkenImageBlob(
    downloadedImage,
    100,
    dpi
  );
  const formData = new FormData();
  formData.append("file", resizedImage);
  return storeService.getStoreLogoZplCode(formData).then(
    (response) => {
      return response.data
        .replace("^XA", "")
        .replace("^XZ", "")
        .replace("^FO0,0", "");
    },
    (error) => {
      customToast(error, toastType.ERROR);
    }
  );
};

//------- Export All Other Component Utilties
export * from "./utilities/userUtility";
export * from "./utilities/storeUtility";
export * from "./utilities/outletUtility";
export * from "./utilities/shopifyUtility";
export * from "./utilities/genericUtility";
export * from "./utilities/saleTradeUtility";
export * from "./utilities/dashboardUtility";
export * from "./utilities/inventoryUtility";
export * from "./utilities/tradeInMarginUtility";
export * from "./utilities/authenticationUtility";
export * from "./utilities/columnHeadersUtility/index";
export * from "./utilities/thirdPartyProductsApiUtility";
